<template>
<b-tabs pills card vertical end>
  <b-tab class="d-flex flex-column" active>
    <template slot="title">
      <i class="far fa-search fa-fw"></i>
    </template>

    <div class="flex-shrink-1">
      <b-link href="https://manual.si.jbsbibleapp.com/#manual-search" class="text-primary" target="_blank"><i class="far fa-question-circle fa-fw"></i> 検索マニュアルはこちら</b-link>
      <b-form-radio-group
        buttons
        button-variant="outline-primary"
        v-model="$store.state.data.search.bookCode"
        :options="$store.getters.bible_search_options"
        class="w-100 mb-1 bible-search-options"
        />
      <b-input-group>
        <b-form-input v-model="search.value" type="search" class="mb-1" @keyup.native='onKeyupSearchKeyword'></b-form-input>
        <b-input-group-append class="mb-1">
          <b-button @click="onClickSearchSubmit"><i class="far fa-search fa-fw"></i></b-button>
        </b-input-group-append>
      </b-input-group>
    </div>

    <div class="flex-grow-1 overflow-y-s">
      <b-list-group>
        <b-list-group-item href="#" class="flex-column align-items-start" v-for="item in search.items" @click="onClickSearchItem($event, item)">
          <div class="d-flex w-100 justify-content-between">
            <small class="text-muted">{{ item.book.toc2 }} {{ item.chapter.code }}:{{ item.code }}</small>
          </div>
          <p class="mb-1">
            {{ item.text }}
          </p>
        </b-list-group-item>
      </b-list-group>
      <p class="w-100" v-if="!search.connecting && search.items.length === 0">
        検索結果がありません
      </p>
      <p v-else>
        <b-button variant="light" class="w-100" @click="onClickSearchMore" :disabled="search.connecting" v-if="search.response && search.response.data.paged < search.response.data.pages">さらに読み込む</b-button>
      </p>
    </div>
  </b-tab>

  <b-tab class="d-flex flex-column">
    <template slot="title">
      <i class="far fa-book fa-fw"></i>
    </template>

    <div id="overview-container" class="flex-grow-1 overflow-y-s">
      <div class="text-center">
          <h5 id="overview-top">概説</h5>
      </div>
      <template v-if="overview.value">
        <div class="text-right">
          <b-button variant="light" @click="onClickOverviewBack">戻る</b-button>
        </div>
        <div v-html="overview.value.overview">
        </div>
        <div class="text-right">
          <b-button variant="light" @click="onClickOverviewBack">戻る</b-button>
        </div>
      </template>
      <template v-else>
        <strong>旧約聖書</strong><br/>
        <div class="row btn-group btn-group-tile btn-group-tile-3">
          <b-button variant="light"
            v-for="(item, index) in $store.state.data.current.bible.bible_books"
            class="text-center col-4"
            v-if="item.type === 'old'"
            @click="onClickOverviewBibleBook($event, item)"
            >
            {{ item.toc2 }}
          </b-button>
        </div>
        <br/>
        <br/>
        <strong>新約聖書</strong><br/>
        <div class="row btn-group btn-group-tile btn-group-tile-3">
          <b-button variant="light"
            v-for="(item, index) in $store.state.data.current.bible.bible_books"
            class="text-center col-4"
            v-if="item.type === 'new'"
            @click="onClickOverviewBibleBook($event, item)"
            >
            {{ item.toc2 }}
          </b-button>
        </div>
      </template>
      <app-buy-layer ticket="premium" variant="white" />
    </div>
  </b-tab>

  <b-tab class="d-flex flex-column">
    <template slot="title">
      <i class="far fa-books fa-fw"></i>
    </template>

    <div class="flex-grow-1 overflow-y-s reference-content">
      <div role="tablist" class="w-100">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1 px-3" style="cursor: pointer;" v-b-toggle.reference-accordion-1>
            序文
          </b-card-header>
          <b-collapse id="reference-accordion-1">
            <b-card-body>
              <div class="html-content">
                <p>日本聖書協会は設立以来、四種類の旧・新約聖書を翻訳刊行しました。まず文語訳聖書として一八八七（明治二〇）年の明治元訳、次に明治元訳の新約聖書だけを改訂した一九一七（大正六）年の大正改訳、戦後は一九五五（昭和三〇）年の口語訳聖書、そして一九八七（昭和六二）年の日本のプロテスタント教会とカトリック教会が初めて共同で発行した新共同訳聖書です。四番目の新共同訳聖書は、従来の旧・新約聖書六十六巻のほか、カトリック教会の第二正典、聖公会がアポクリファとして認める文書、計一三書を収めた「続編付き」聖書も発行しました。</p>
                <p>幸いに新共同訳はその後三十年余にわたり、多くのプロテスタントとカトリックの教会で愛用され、教会一致（エキュメニズム）の生きたしるしとなりました。</p>
                <p>新共同訳刊行から二十年近くが経過した頃、日本語としての完成度をより高め、その後の学問上の進展を取り入れた、日本語の変化に対応する、次世代の新たな翻訳聖書の必要性を感じました。そこで日本聖書協会は二〇〇五年一一月に翻訳部を新設し、聖書の新翻訳事業に関する検討と準備を開始しました。二〇〇八年六月の理事会では共同訳事業推進計画のための諮問会議の設置を決議しました。国内三二教団・一団体に同諮問会議への派遣議員をお願いしたところ、一七教団・一団体がこの諮問会議に議員を推薦してくださり、二十一名の議員から成る諮問会議を二〇〇八年一〇月から四回にわたり開催しました。最終回の二〇〇九年一〇月六日には、答申としてスコポス理論を採用した「翻訳方針前文」を採択し、同年一二月の日本聖書協会の理事・評議員会ではこの答申を承認し、新翻訳事業が開始されたのです。</p>
                <p>以下にこの「翻訳方針前文」の本文（一部省略）を掲げます。</p>
                <p>&nbsp;</p>
                <p>「近代日本における福音宣教の開始後、聖書はいち早く日本語に訳された。それは教会の正典として用いられただけでなく、言語、文学、思想など、日本文化全体の発展にも貢献した。過去の聖書協会による邦訳聖書刊行だけを見ても、（中略）およそ三〇年おきに改訂あるいは新訳がなされている。翻訳作業に一〇年かかるとすれば、『新共同訳』が刊行されて二〇年が過ぎた現在、聖書の新しい訳が検討されるべき時期が来ていると言えよう。実際、過去数十年間に生じた聖書学、翻訳学などの進展、底本の改訂、日本語や日本社会の変化、また『新共同訳』見直しへの要請が、新しい翻訳を求めている。</p>
                <p>新しい聖書翻訳は、</p>
                <p>⑴ 共同訳事業の延長とし、日本の教会の標準訳聖書となること、また、すべてのキリスト教会での使用を目指す。</p>
                <p>⑵ 礼拝で用いることを主要な目的とする。そのため、礼拝での朗読にふさわしい、格調高く美しい日本語訳を目指す。</p>
                <p>⑶ 義務教育を終了した日本語能力を持つ人を対象とする。</p>
                <p>⑷ 言語と文化の変化に対応し、将来にわたって日本語、日本文化の形成に貢献できることを目指す。</p>
                <p>⑸ この数十年における聖書学、翻訳学などの成果に基づき、原典に忠実な翻訳を目指す。底本として、旧約（ＢＨＱ）・新約（ＵＢＳ第５版）・旧約続編（ゲッティンゲン版）など、最新の校訂本をできる限り使用する。</p>
                <p>⑹ 文学類型の違いを訳出して原典の持つ力強さを伝達する努力はするが、聖書が神の言葉であることをわきまえ、統一性を保つ視点を失わないこととする。固有名詞や重要な神学用語については『新共同訳』のみならず、過去の諸翻訳も参考にして、最も適切な訳語を得るようにつとめる。</p>
                <p>⑺ その出版に際して、異読、ならびに地理や文化背景などを説明する注、引照聖句、重要語句を解説する巻末解説、小見出し、章節、地図や年表、などの本文以外の部分は、できる限り様々な組み合わせを考え、読者のニーズに応える努力をする。」</p>
                <p>&nbsp;</p>
                <p>『聖書 新共同訳』が共同訳聖書実行委員会の責任の下に翻訳されたのに対して、同じ共同訳とはいえ、今回の新翻訳事業は日本聖書協会理事会の決議の下に開始されました。そのため、翻訳と発行に関する責任者という意味で書名を『聖書 聖書協会共同訳』と致しました。各書の書名や、「続編付き」の扱い、固有名詞（一部の変更を除いて）の表記については、新共同訳を踏襲しています。その意味で、聖書協会共同訳は新たな翻訳ではありますが、新共同訳のプロテスタントとカトリックの教会との共同作業を基盤にしたものです。</p>
                <p>『聖書 聖書協会共同訳』の最も重要な特徴は、スコポス理論を採用した「翻訳方針前文」にあるとおり、翻訳の主要な対象・目的を教会での礼拝における使用とし、礼拝での朗読にふさわしい、格調高く美しい日本語訳を目指した点です。この方針を実現すべく、原語担当者と日本語担当者が最初から共同で翻訳を行い、訳稿を作成するという翻訳方法を採用するとともに、朗読チェックや外部モニターの評価、さらには編集を終えた全書の「パイロット版」への一般読者からのご意見を翻訳に反映させるように努めました。</p>
                <p>聖書協会共同訳のもう一つの大きな特徴は、刊行当初から、本文のほかに引照と注を付した形で発行される点です。特に重要な異読や別訳を示す「注」を旧・新約聖書全体に付けたのは、過去に大正改訳の際に新約聖書について行われた以外は、日本聖書協会発行の聖書として初めてのことです。</p>
                <p>新翻訳事業の翻訳作業には、翻訳者六二名、編集委員四三名、外部モニター二〇名、検討委員二三名の延べ一四八名がご協力くださいました。二〇一〇年の翻訳開始から二〇一七年の翻訳終了までの七年間、七回の検討委員会、二回の全体会議（二〇一一年、一二年）、九回の翻訳者委員会合宿（二〇一三～一七年）を含む約一五〇回の翻訳者委員会、五書・歴史書、詩書・預言書、続編、新約の四委員会に分けての計二五回の編集委員会が開催されました。さまざまな本務を持ちながらこの翻訳事業のために貴重な時間と労力を惜しみなく献げてくださった方々に心より感謝申し上げます。何よりも新翻訳事業に賛同し、ご協力くださった教団と団体、また、祈りと献金によって事業をお支えくださった多くの方々に対して深く感謝を表したいと思います。</p>
                <p>&nbsp;</p>
                <p>二〇一八年一一月</p>
                <p>一般財団法人日本聖書協会</p>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
    
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1 px-3" style="cursor: pointer;" v-b-toggle.reference-accordion-2>
            凡例
          </b-card-header>
          <b-collapse id="reference-accordion-2">
            <b-card-body>
              <p>一．漢字には、数詞を含め、振り仮名を付けることを原則とした。</p>
              <p>なお、訳語「洗礼」については、「せんれい」と読む場合のほか、「バプテスマ」と読む場合を考慮し、例外として〔バプテスマ〕の振り仮名を付した。</p>
              <p>二．固有名詞表記は、一部の例外を除いて、『聖書 新共同訳』の表記に準拠した。</p>
              <p>三．章・節区分および使用した記号</p>
              <p>⑴ 章・節の区分は、各底本に従った。『聖書 新共同訳』と同様に、特に旧約聖書における、日本聖書協会「口語聖書」などの聖書の章・節の区分と相違する箇所については、付録の「旧約聖書 章・節対照表」で表示した。</p>
              <p>⑵ †</p>
              <p> 底本に節が欠けていることを示す。新約聖書においては、この部分の異本による訳文を当該書の末尾に付した。</p>
              <p>⑶ ――</p>
              <p> 挿入と見るのが一般的とされている箇所、および意味上、挿入句として読むほうが理解しやすい箇所などに用いた。</p>
              <p>⑷ 〔&emsp;&emsp;〕</p>
              <p> 新約聖書においては、後代の加筆と見られているが年代的に古く重要である箇所を示す。旧約聖書続編においては、主な写本に欠けている節を底本が別の写本で補った箇所とテキストの字体に大小の区別がある箇所を示す。</p>
              <p>四．小見出し</p>
              <p> 本文の内容区分ごとの概括的な理解を助ける趣旨から、一部の書を除き、小見出しをゴシック体で示した。小見出しは（旧約聖書続編の一部の書を除いて）本文ではない。なお、その下に（&emsp;&emsp;）がある場合、書の略語、章・節数字は、関連箇所を示す。</p>
              <p>五．度量衡および通貨については、『聖書 新共同訳』と同様、元の単位を原語の発音に近い表記で表した。付録の「度量衡および通貨」を参照。</p>
              <p>六．本聖書の底本は次のとおり。</p>
              <p>⑴ 旧約聖書</p>
              <p>「ビブリア・ヘブライカ・シュトットガルテンシア」（ドイツ聖書協会）および、「ビブリア・ヘブライカ・クインタ」のすでに発行されている分冊（同）</p>
              <p>⑵ 新約聖書 「ギリシア語新約聖書（修正第五版）」（ドイツ聖書協会）</p>
              <p>⑶ 旧約聖書続編 「ギリシア語旧約聖書」（ゲッティンゲン研究所）</p>
              <p>※『エズラ記（ラテン語）』「ウルガタ版聖書」（ドイツ聖書協会）</p>
              <p>&nbsp;</p>
              <h6>引照と注について</h6>
              <p>一．引照</p>
              <p>⑴ 引照は、聖書本文の関連する箇所を選び、本文下の欄外に示したものである。</p>
              <p>⑵ 本文の引照箇所は、主要語の右肩に数字 1） 2） 3）…の引照記号を付けて示し、欄外では① ② ③…とした。以下の二で示す注は、引照の後にアルファベットabc…の注記号を付けて示し、欄外では各頁ごとに引照の後に罫線を引いて掲げた。引照が多数あり、次頁にはみ出す場合には、次頁の引照・注と区別する意味で、その間に二重罫線を引いた。</p>
              <p>⑶ 引照が節全体に及ぶ場合には、その節数字の右に引照記号を付記した。</p>
              <p>⑷ 引照が複数の節あるいは章を越えて及ぶ場合には、その範囲を欄外に（&emsp;&emsp;）の形で示した。</p>
              <p>⑸ 引照が小見出しで区切られた箇所全体に及ぶ場合には、小見出しの右肩に引照記号を付けて、引照箇所を示した。</p>
              <p>⑹ 引照は、頁ごとにまとめて掲げることとし、必ずしも引照箇所の行の真下に置いていない。</p>
              <p>⑺ 引照は、旧新約のみの版と旧約聖書続編付きの版で共通とした。聖書各書の略語については、各版の目次を参照のこと。なお、章数は漢数字で、節数はアラビア数字で示し、章数と節数の間に「・」 は付さない。</p>
              <p>&nbsp;</p>
              <p>二．注</p>
              <p> 注には、以下の種類がある。なお、同一章の中に繰り返される場合は、初出のもののみを記す。</p>
              <p>⑴ 本文注（底本に関わる注）</p>
              <p>1 底本が不明瞭なため、他の写本や古代訳を参考に訳した場合、その参考にした写本や古代訳の略語と底本の訳を記す。例：<i class="bible-abbr bible-abbr-old-other-lxx"></i>による。<i class="bible-abbr bible-abbr-old-leningrad"></i>「栄光」</p>
              <p>2 底本が不明瞭だが、他の写本や古代訳に参考となる資料がなく、修正を加えた場合は、<i class="bible-abbr bible-abbr-old-correction"></i>という略語と底本の訳を記す。例：<i class="bible-abbr bible-abbr-old-correction"></i><i class="bible-abbr bible-abbr-old-leningrad"></i>「いいえ」</p>
              <p>3 旧約聖書ではケティーブもケレーも底本として扱うため、どちらを取っても注記しない。</p>
              <p>⑵ 別訳</p>
              <p> 重要な聖書の箇所において訳文が過去の聖書協会訳と大きく異なる場合は、従来の訳を「別訳」として注記する。別の訳し方が可能な場合も「別訳」として示した。</p>
              <p>⑶ 直訳、補足、あるいは</p>
              <p> 本聖書は自然な日本語を目指しているため、翻訳上さまざまな工夫がなされている。しかし、特別に必要と思われる場合に限り、㈠「直訳」として原文の形に近い訳文を記した。㈡補足した文言を記して「補足」とした。㈢「あるいは」として近い意味の訳語を記した。</p>
              <p>⑷ 言葉遊び、地名などの由来</p>
              <p> 原文において掛詞や言葉遊びがあり、それが地名の由来となるなど、重要と思われる場合に注記する。</p>
              <p>&emsp;&emsp;例一：<i class="bible-abbr bible-abbr-old-leningrad"></i>アダマ （ヘブライ語では「アダマ」である。）</p>
              <p>&emsp;&emsp;例二：「得た」の<i class="bible-abbr bible-abbr-old-leningrad"></i>より （このヘブライ語は、文脈に見られる「得た」と訳されたヘブライ語の派生語、あるいは、そのヘブライ語に音が類似している言葉である。）</p>
              <p>⑸ その他</p>
              <p> 名詞などが注で記されている場合は、日本語の観点から本文の文言となったが、実際は注に記されたものであることを示す。例：本文で「箕」、注で「農用フォーク」</p>
              <p> なお、本聖書の注で用いる略号は次のとおりである。</p>
              <table class="table table-bordered mt-5">
                <thead>
                  <tr class="legend-bible-type table-secondary">
                    <th scope="col" colspan="2">旧約聖書</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-leningrad"></i></th>
                    <td>底本（レニングラード写本）</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-qere"></i></th>
                    <td>底本・読み（ケレー）</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-ketiv"></i></th>
                    <td>底本・子音字本文（ケティーブ）</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-correction"></i></th>
                    <td>修正</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-other-hebrew"></i></th>
                    <td>他のヘブライ語写本</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-qumran"></i></th>
                    <td>クムラン（死海）写本</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-targum"></i></th>
                    <td>アラム語（タルグム）</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-other-aramaic"></i></th>
                    <td>タルグム以外のアラム語</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-lxx"></i></th>
                    <td>七十人訳ギリシア語聖書</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-other-lxx"></i></th>
                    <td>他の七十人訳ギリシャ語聖書写本</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-samaritan"></i></th>
                    <td>サマリア五書</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-syriac"></i></th>
                    <td>シリア語（ペシッタなど）</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-vulgata"></i></th>
                    <td>ウルガタ</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-old-other"></i></th>
                    <td>その他の写本</td>
                  </tr>
                </tbody>
                <thead>
                  <tr class="legend-bible-type table-secondary">
                    <th scope="col" colspan="2">旧約聖書続編</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-apo-greek"></i></th>
                    <td>底本（ギリシア語）</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-apo-latin"></i></th>
                    <td>底本（ラテン語）</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-apo-other-reading"></i></th>
                    <td>底本以外の読み</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-apo-hebrew"></i></th>
                    <td>ヘブライ語写本</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-apo-syriac"></i></th>
                    <td>シリア語写本</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-apo-vulgata"></i></th>
                    <td>ウルガタ</td>
                  </tr>
                </tbody>
                <thead>
                  <tr class="legend-bible-type table-secondary">
                    <th scope="col" colspan="2">新約聖書</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-new-greek"></i></th>
                    <td>底本</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-new-other-reading"></i></th>
                    <td>底本以外の読み</td>
                  </tr>
                  <tr class="legend-data">
                    <th scope="row"><i class="bible-abbr bible-abbr-new-vulgata"></i></th>
                    <td>ウルガタ</td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>
    
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1 px-3" style="cursor: pointer;" v-b-toggle.reference-accordion-3>
            聖書地図
          </b-card-header>
          <b-collapse id="reference-accordion-3">
            <b-card-body>
              <div class="mb-3 copyguard">
                <h6>1.古代近東</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map001.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>2.エジプトとシナイ</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map002.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>3.カナンの分割</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map003.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>4.イスラエル王国とユダ王国</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map004.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>5.アッシリア帝国と新バビロニア帝国</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map005.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>6.ペルシア帝国</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map006.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>7.マカバイ時代のパレスティナ</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map007.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>8.ローマ帝国の拡張（前27〜後180年）2</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map008.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>9.イエス時代のパレスティナ</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map009.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>10.イエス時代のエルサレム</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map010.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>11.パウロの第一次および第二次宣教旅行</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map011.png'" >
              </div>

              <div class="mb-3 copyguard">
                <h6>12.パウロの第三次宣教旅行とローマへの旅</h6>
                <img class="img-fluid w-100 mx-auto d-block" v-lazy="'https://s3-ap-northeast-1.amazonaws.com/bibap.bible.or.jp/images/map012.png'" >
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1 px-3" style="cursor: pointer;" v-b-toggle.reference-accordion-4>
            聖書について
          </b-card-header>
          <b-collapse id="reference-accordion-4">
            <b-card-body>
              <div class="html-content">
                <p>「私が仕えているイスラエルの神，主は生きておられる」（王上17：1）。</p>
                <p>物語の初めに見られるこの言葉は，聖書の全内容を表している。聖書は，神と人間との歴史における出会いの物語である。この体験物語は，東地中海の諸国を舞台に，アブラハムとその子孫を中心に展開し，千有余年に及ぶ。唯一神への信仰は，紀元一世紀の終わりには，東地中海のあらゆる国に向けられ，多くの民族に，ついに全世界に伝えられることになる。</p>
                <p>に応じて，ヘブライ語，アラム語，ギリシア語の三か国語で記されている聖書は，この神体験の集大成である。キリスト教では，これらの文書は旧約聖書と新約聖書の二つにまとめられている。旧約聖書は，アブラハムの子孫であるイスラエル民族と神との関係を述べている。神は，この民をエジプトでの奴隷状態から解放し，シナイ山で契約を結び，約束の地カナンを与え，さらにその後の歴史の歩みによって自らを知らせる。そこには，神による救いの体験に基づいて，未来の決定的救い主を待望させる数々の劇的な物語も織り込まれている。来るべき救い主はメシアと呼ばれ，新約時代になると，ユダヤ人以外の人々も，イエスを約束の救い主と信じ，メシアのギリシア語訳である「キリスト」の称号をこのイエスに付与することになる。初期キリスト者は，いち早く，イエスこそが，その言葉，行為，死，復活を通して，神がその民に与えた約束を実現したこと，そして，旧約の預言者エレミヤが告げた新しい契約（エレ31：31-34）を完成したことを確信する。新約の使徒の一人であるパウロは，「コリントの信徒への手紙2」（3：14）で，イスラエルの指導者モーセを通して結ばれたシナイ山の契約に言及するとき，これを古い契約と呼んでいる。以来キリスト者は，この契約を中心として書かれた諸文書を「旧約聖書」，イエスによる新しい契約を中心として書かれた諸文書を「新約聖書」と呼び，これらを神の言葉，聖書として受け入れた。「新約」は「旧約」に取って替わったとはいえ，新約聖書を理解するためには旧約聖書を知ることがどうしても必要であり，両者は同一の神について語る連続の書である。</p>
                <p>聖書の神は，その冒頭から，言葉において働く神であり，人間に働きかける。神はアブラハムに話し，アブラハムは行動を起こす。モーセは神の言葉を聞いてエジプトからの脱出を敢行する。イザヤとエレミヤは神の言葉を民に語る。「ヨハネによる福音書」は，イエスを神の言葉と呼んでおり（ヨハ1：1），事実，イエスにおいて，神が人間に伝えようとすることが余すところなく集められている。聖書の著者はすべて，その名前が知られていると否とにかかわらず，共通して神の言葉の証人であり，彼らのおかげで，今日もこの言葉は私たちの生き方を照らし，教え，導き，人々に新しい救いを与える。</p>
                <p>&nbsp;</p>
                <h6>旧約聖書</h6>
                <p>聖書の最初の五つの書は「モーセ五書」と呼ばれるが，新約の福音書でこれらの書は通常「律法」と言われている。神の民が，シナイ山で結ばれた契約にふさわしく生きるのに必要なことが含まれているからである。「創世記」には天地万物，人間，イスラエル民族の起源が述べられており，特に，アブラハム，イサク，ヤコブ，ヨセフといったイスラエルの民の先祖が紹介されている。第二の書である「出エジプト記」は，その名称が示すとおり，イスラエルの民のエジプトからの脱出とシナイ山での契約を述べている。これに続く三書では，この契約によって求められた生き方が記されている。「レビ記」は，レビ族に託された宗教的，民事的法規を収めたものである。「民数記」は，荒れ野滞在時代の人口調査からその名を得ている。「申命記」は，エジプト脱出と荒れ野滞在中の出来事の意味と，約束の地に入る際に守るべき神の律法を述べながら神への誠実を説く，長い勧告の書である。</p>
                <p>モーセ五書に，イスラエルの民の歴史的な体験を物語る文書（歴史書）が続く。生ける神と人間との出会いは，イスラエルの生活の中で展開したからである。これらの書を読むと，長い歴史の歩みの中で，イスラエルの民が忠実であるときにも，不忠実であるときにも，神がどのようにしてその民と共におられたかを知ることができる。</p>
                <p>これらの文書は大別して二種類のイスラエル史から成っている。一つは「ヨシュア記」「士師記」「サムエル記」「列王記」から成り，もう一つは「歴代誌」「エズラ記」「ネヘミヤ記」から成っている。第一のイスラエル史の中で，「ヨシュア記」は，モーセの後継者であるヨシュアの指導のもとでなされたカナン征服と，イスラエルの十二部族に与えられた土地の分割を述べている。「私がモーセと共にいたように，私はあなたと共にいる。あなたを見放すことはなく，あなたを見捨てることもない」（ヨシュ1：5）。これが聖書全体の伏線となる本書の主題である。勝利の喜びが全体的に感じられる。</p>
                <p>「士師記」では，カナン定着に伴う種々の困難な出来事の中で，イスラエル人の心がカナン住民の礼拝する神々に傾き，しばしば近隣の民に屈服させられた経緯が語られる。この苦難のとき，民は神への不誠実を悔い，神に立ち帰って，その助けを願う。神は民の過ちにもかかわらず，この呼びかけに応え，救済者として「士師たち」を遣わす。神は真に民の「救い主」である。</p>
                <p>「サムエル記」の上下二巻は，部族の統合がいかになされ，サウルとダビデによる中央集権がいかに形成されたかを物語っている。ここに王朝が成立する。「列王記」の上下二巻は，王朝の終わるエルサレム没落までを述べる。神の要求を具体的に知らせる預言者が現れるのはこの時期であり，彼らの文書である預言書は旧約聖書の終わりに収められている。</p>
                <p>「士師記」における不誠実と悔い改めの物語の直後に，ルツというモアブ人女性の誠実を物語る短編「ルツ記」が挿入されている。その誠実な生涯の結果，彼女は偉大な王ダビデの系図に名を連ねることになる。</p>
                <p>第二のイスラエル史の中心点は，エルサレムとその神殿である。「歴代誌」の上下二巻はダビデとソロモンのもとでの神殿建築と礼拝を述べ，「エズラ記」と「ネヘミヤ記」の両書は，捕囚の身となった民のバビロニアからの帰還，破壊された神殿の捕囚後の再建と，エルサレムのユダヤ人共同体の形成を描いている。</p>
                <p>「エステル記」は，捕囚となった一ユダヤ人女性が，ユダヤ人絶滅をたくらむ陰謀をいかに挫折させたかを物語っている。</p>
                <p>千有余年の間，神がその民のうちに現存した事実を物語る以上の各書に，知恵文学の諸書が続く。「ヨブ記」は旧約聖書の最も劇的な書の一つであり，ヨブとその友人との対話形式による長い詩である。苦しむヨブが「理由なしに神を畏れるでしょうか」（1：9）ということが対話の主題であり，それはヨブ一人の問題ではなくて，苦しむ義人すべての問題でもある。「詩編」は，共同あるいは個人の種々の祈りを収めたもので，賛美の詩，感謝の詩，嘆きの詩等から成っている。あるものは救いの歴史を思い巡らすものであったり，あるものは神を迎えるための生き方を考えるものであったりする。</p>
                <p>「箴言」は，人生のさまざまな状況の中で，神の前での正しい生き方を教える知恵者たちの金言集である。ここに示される賢明な行動のみが人間に有益である。「コヘレトの言葉」は，死に運命づけられた人間の生の意義について考えた，ある知恵者の書である。「雅歌」は愛の歌を集めたものであり，ユダヤ人もキリスト者も伝統的に，これを神と人間との相互愛の象徴的表現と見る。</p>
                <p>旧約聖書は，預言者の説教の集大成で終わる。預言者とは，神の言葉を語るために神によって召し出された人々である。</p>
                <p>「イザヤ」は，紀元前八世紀の後半，アッシリア帝国の最盛期にエルサレムに遣わされた神の使者であり，王と住民全体を，どんなときも神に信頼し，神に従うように招く。本書の第二部（40～55章）は，バビロニアに移されたユダヤ人に向けられ，第三部（56～66章）は未来のエルサレムを歌っている。</p>
                <p>「エレミヤ」も，エルサレムの住民に語るが，時代的にはイザヤの一世紀以上後の新バビロニア帝国の初期のことである。エレミヤは民を愛しているが，破局の近いことを告げる孤独の人であり，しばしば迫害される。彼はエルサレムの陥落と王朝の最後の目撃者である。「哀歌」は，五つの歌から成り，このエルサレムの滅亡を嘆く。</p>
                <p>「エゼキエル」は，エルサレムの神殿の祭司であり，エレミヤと同時代に活躍する。バビロンに移され，捕囚の民のもとで使命を果たす。しばしば人の思いも及ばぬ行動と弁舌に走るが，エルサレムの荒廃を知ると，その説くところは変わり，生存者に慰めと救いの使信を告げる。</p>
                <p>「ダニエル」は，バビロニア王の宮廷に仕えているユダヤ人の青年として現れ，迫害の中の信仰者に対し，信仰を堅持し神の最終的勝利を希望するよう促す。</p>
                <p>これらの四つの預言書に，他の預言者たちの説教を伝える短い文書が加えられ，十二小預言書と呼ばれる。これらの預言者の中には，イザヤやエレミヤと同時代の人もいる。たとえば前八世紀中頃，イスラエル王国の隆盛時代に活躍した「アモス」は，形式的な礼拝と貧者への圧迫を告発する。その後しばらくして現れた「ホセア」は，民に対する神の愛，欺かれた愛を告知する。イザヤと同時代の人「ミカ」も，ユダの住民や，不忠実な民に対して神が起こす訴えを語り，第二のダビデの到来を告げる。「ヨナ書」は，やや趣を異にし，ニネベの住民に悔い改めを迫る預言者ヨナの体験を物語っている。「ハガイ」と「ゼカリヤ」は，捕囚のイスラエルのバビロニアからの帰還後，神殿の再建に協力しており，「マラキ」は，神の正しい裁きと救いの日が訪れることを告げる。</p>
                <p>&nbsp;</p>
                <h6>旧約聖書続編</h6>
                <p>旧約聖書続編と呼ばれるこの文書群は，一世紀末ユダヤ教で聖書の正典目録を定めるときに受け入れられず，ユダヤ人の聖書には含まれていない。しかし，もともとは紀元前三世紀ないしは二世紀から紀元後一世紀までの間に成立したユダヤ教の宗教的文書である。これらは歴史記述から知恵文学，民間説話，黙示文学など幅広い様式で記され，高い文学性を備えており，紀元前後のユダヤ教の多様性を伝える文書群である。「知恵の書」と「マカバイ記 2」を除く他の諸書は，まずヘブライ語またはアラム語で記され，パレスティナ以外の地に住んでこれらの言語を解しないユダヤ人のために旧約の他の書と同様に，ギリシア語に訳されたものである。初期のキリスト教では，ギリシア語がいち早く共通語となり，キリスト者は離散（ディアスポラ）のユダヤ人たちが用いた「ギリシア語訳旧約聖書（七十人訳聖書）」と共に先の文書群も受け継いだ。</p>
                <p>「七十人訳聖書」や「ラテン語訳聖書（ウルガタ）」などに含まれていたこれらの宗教的文書は，ユダヤ教に発するものではあるが，主にキリスト教の中で読まれてきた。キリスト教内で四世紀ごろからこの文書について，二つの見解が見られるようになる。すなわち，これは旧約の他の書に劣るとする見方と，同等とする見方である。今日，カトリック教会ではこれに旧約と同等の価値が付され，「第二正典」と呼ばれる。もっとも，「エズラ記（ギリシア語）」，「エズラ記（ラテン語）」，「マナセの祈り」は，カトリック教会もまた「アポクリファ」と呼んでいる。プロテスタント教会では，その価値を認める教会もあれば，これらのすべてを全く認めない教会もあり，そこでは「アポクリファ」あるいは「外典」と呼ばれる。本聖書ではこの部分全体について，『聖書 新共同訳』で用いられたように「旧約聖書続編」という用語を採用する。</p>
                <p>十九世紀までは，一般に旧約続編も翻訳して出版されていた。カトリックとギリシア正教では旧約の他の書の間に，十六世紀初めの若干のカトリック聖書と多くのプロテスタント聖書では，旧約と新約との中間に，まとめて置かれていた。本聖書は後者の慣例に従っている。（この慣例は，1987年に教皇庁キリスト教一致推進秘書局と聖書協会世界連盟が共同で改訂版を発表した「聖書翻訳におけるプロテスタントとカトリックの共同作業のための指針」が定めているところとも一致する。）</p>
                <p>「トビト記」と「ユディト記」は，教訓を交えつつ，困難な状況の中で神を信頼し，その教えにいかに忠実に生きるかを示した民間説話である。ギリシア語本文による「エステル記」は，ヘブライ語の「エステル記」に，モルデカイやエステルの祈りなど，多少の付加をしたものである。「マカバイ記」の二巻はそれぞれ独立の書であるが，いずれも紀元前二世紀，パレスティナのユダヤ人に対する宗教的な迫害のゆえに起きた闘争を語る歴史記述である。</p>
                <p>「知恵の書」と「シラ書」は，知恵文学に属し，知恵の追求を根本に置いている。とりわけ後者は実践的な訓告が散りばめられ，日常生活や人生の諸問題への指針を与えている。「バルク書」と「エレミヤの手紙」は，預言書に類似した文書で，前者は罪の告白，知恵についての思索，エルサレムの慰めから成っている。後者は偶像崇拝に対する警告である。「ダニエル書補遺」は「七十人訳聖書」に収められており，「アザルヤの祈りと三人の若者の賛歌」など，ダニエルを中心人物とする三つの教訓的短編が含まれる。</p>
                <p>「エズラ記（ギリシア語）」「エズラ記（ラテン語）」「マナセの祈り」は，「エズラ記（ラテン語）」を除いて，キリスト教の聖書のギリシア語写本によって伝えられ，いずれもカトリック教会では正典の中に数えられていない。「第三エズラ記」「第四エズラ記」「マナセの祈り」の名称でラテン語聖書の付録として出版されていたが，聖公会の聖書ではアポクリファに加えられている。</p>
                <p>「エズラ記（ギリシア語）」の主題は，ヨシヤ，ゼルバベル，エズラによる礼拝の改革であり，これについての史料を提供する。「エズラ記（ラテン語）」は黙示文学に属し，おそらく一世紀末に書かれたと思われ，悪，苦しみ，迫害の問題や，神の裁きを述べている。「マナセの祈り」は短い文書だが，神に罪を告白し，赦しを乞い求める美しい祈りの言葉が綴られている。</p>
                <p>&nbsp;</p>
                <h6>新約聖書</h6>
                <p>「神は，かつて預言者たちを通して，折に触れ，さまざまなしかたで先祖たちに語られたが，この終わりの時には，御子を通して私たちに語られました。」</p>
                <p>「ヘブライ人への手紙」冒頭（1：1，2）のこの句は，新約聖書全体を巧みに要約している。アブラハム，モーセ，預言者たちを呼び出し，イスラエルの民の長い歴史を通して自らを知らせた生ける神は，民との完全な出会いを実現し，エレミヤが告げた新しい契約を結ぶため，ついにその独り子を送る。「ヨハネによる福音書」はこの独り子を紹介して，「私を見る者は，私をお遣わしになった方を見るのである」（ヨハ12：45）というイエスの言葉を伝えている。新約聖書はまさに，イエス・キリストを通して与えられる神と人間との決定的な出会いと，各人にとってのその意義を物語る書である。比較的短い二十七の書物は，福音書，「使徒言行録」，手紙，「ヨハネの黙示録」から成っている。</p>
                <p>福音は，イエスがもたらした決定的な救いの恵みであり，福音書は，このイエスがその短い生涯で行い，教えたことを伝え，イエスの死と復活を語る。これは伝記というよりも，イエスによって生きた人々の証言の記録である。</p>
                <p>「マタイによる福音書」は，ユダヤ教から改宗したキリスト者に特に留意して編集されている。ここにはイエスが旧約の約束と待望の成就であることが力説され，イエスの教えは，五つの大説教（5～7章，10章，13章，18章，24～25章）の形で紹介されている。</p>
                <p>「マルコによる福音書」は，異邦人の改宗者を対象としており，福音の言葉によって絶えず働いているイエスに従うよう，人々を招いている。</p>
                <p>ルカは，「ルカによる福音書」と「使徒言行録」の著者である。前者はギリシア文化に親しんでいる読者に向けられており，ユダヤ人のみならずすべての人の救い主であるイエスが，特に弱い者，小さい者や罪人（つみびと）に近づいてこれに福音を語ることが強調されている。また，エルサレムで十字架にかかり，復活するためにエルサレムに上るイエスの姿を伝えるが（9：51～19：27），この死と復活の神秘こそ，地の果てまで告げ知らされる聖書の救いの使信の核心である。「使徒言行録」は，イエスがもたらした救いの告知がペトロ，パウロなどによってエルサレムに始まり，サマリア，シリア，ギリシアから，ローマまでに広がる経過を描いている。</p>
                <p>「ヨハネによる福音書」は，読者がイエスを神の独り子と信じて永遠の命を得るように記され，イエスの言行のうち特に意味深いものを伝えようとしている。</p>
                <p>パウロの手紙は，彼が創設した諸教会，訪ねようと思うローマのキリスト教徒，あるいは彼の協力者に宛てられたもので，手紙の配置は，年代順ではない。</p>
                <p>「ローマの信徒への手紙」は，神の恵みの力，罪人である人間の姿，信仰による救い，信仰者の新しい生き方，死んで復活したキリストとの一致，また聖霊による新しい生活など，パウロの説教の重要な主題を扱っている。</p>
                <p>「コリントの信徒への手紙」は，パウロが一年半滞在して創設したコリントの教会に宛てられている。その中の「第一の手紙」は，彼の出発後分裂した共同体を一致させ，提起された諸問題に答えている。よく知られている「愛の賛歌」は13章に見られる。「第二の手紙」は，パウロの不在中に反対者が現れたコリント教会の危機時代をかいま見せ，パウロの和解の熱意と和解に続く大きな喜びが知らされる。パウロは8～9章でエルサレムの教会への献金を勧めている。最後の10章～13：12は，パウロが激しい語調で，使徒である自己を主張しつつ相手に訴える内容となっている。</p>
                <p>「ガラテヤの信徒への手紙」も，異なる信仰の危機への応答であり，パウロは，キリストがもたらした新しい契約について情熱を傾けて語る。</p>
                <p>続く三つの手紙と「フィレモンへの手紙」は，パウロが牢獄で書いたものである。まず，「エフェソの信徒への手紙」はユダヤ人，異邦人を問わず，キリスト者はすべてキリストに一致して，キリストの体を形づくっていることを説いた後，後半では，この一致を日常生活の中で生きるように促している。フィリピはパウロが創設した西洋の最初の教会であり，「フィリピの信徒への手紙」には援助への感謝が述べられている。パウロは獄中にあっても，キリストによる喜びと信頼とに満たされており，喜びの手紙と言われる。コロサイはエフェソの東方の町で，キリスト教の共同体はパウロの弟子によって創設された。パウロは「コロサイの信徒への手紙」の中で，種々の宗教思想によって惑わされているキリスト者を助けるために，救いにおけるキリストの卓越した役割を説く。</p>
                <p>「テサロニケの信徒への手紙1」は，パウロが書いた最初の手紙であり，彼はこの手紙で，信仰が未熟で，迫害にさらされているキリスト者たちを力づける。「第二の手紙」は，キリストの再臨を見られないのでないかとの不安を抱くキリスト者に答えている。</p>
                <p>「テモテ」と「テトス」はパウロの協力者で，パウロは彼らに託された教会をよく指導するよう励ます三つの手紙（「テモテへの手紙1，2」と「テトスへの手紙」）を送る。「フィレモン」はパウロの友人，協力者であり，獄中のパウロは，主人のもとから逃亡し自分のところでキリスト者となった，フィレモンの奴隷オネシモを兄弟として迎えるよう勧告する。</p>
                <p>「ヘブライ人への手紙」は，長い勧告の書であり，旧約聖書を引用しながら，キリストが預言者，天使，モーセにまさること，またその祭司職は旧約のそれにはるかにまさることを示し，有名な11章では，信仰のすばらしさについて述べる。</p>
                <p>続く手紙は，ヨハネの三つの手紙を除き，キリスト者全般に宛てられたものである。「ヤコブの手紙」は，信仰生活の実際的側面，特に共同体内での人間関係や病者への接し方に指針を与える。「ペトロの手紙1」は，迫害によって失意のうちにあるキリスト者を勇気づけ，「ペトロの手紙2」と「ユダの手紙」は，異端に対して信仰を純粋に保つよう求める。「ヨハネの手紙1」は神の愛を語る。この手紙と「ヨハネの手紙2」は，神の子の受肉を否定する説に直面しているキリスト者の信仰を強める目的で書かれている。「ヨハネの手紙3」は，単独で共同体の指導者になろうとする人物を非難する。</p>
                <p>新約聖書は，人間を救う神の計画が，キリストの輝かしい再臨に向かって，どのように完成されるかを数々の幻で示す「ヨハネの黙示録」で終わる。これは迫害の下に苦しむキリスト者を励ます書である。</p>
                <p>読者がこの聖書を通して，生ける神と出会い，日々の生活の中で救いを見いだせるようにと祈ってやまない。</p>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1 px-3" style="cursor: pointer;" v-b-toggle.reference-accordion-5>
            用語解説
          </b-card-header>
          <b-collapse id="reference-accordion-5">
            <b-card-body>
              <p>聖書協会共同訳聖書の翻訳にあたっては，平易な日本語を使用するように努めたが，聖書特有の用語や表現を全く用いないことは不可能であるので，それらの用語のうち143語を選んで簡単な解説を加えることにした。以下の解説は，あくまでも読者の理解を助けるための参考となる最小限の説明であって，注解や辞典，あるいは事典に代わるものではない。なお，人名，地名等の固有名詞は原則として除外した。下線印は当該項目を参照の意。</p>

              <b-link v-b-toggle.dictionary-collapse-1 class="m-1 text-dark dic-title">証（あかし）</b-link>
              <b-collapse id="dictionary-collapse-1">
                <b-card>証言，証明などの一般的意味のほか，新約では，神の意志またはイエス・キリストについての証言という特別な意味で用いられる（ヨハ1：7，8，15，32，34，5：31以下，使4：33など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-2 class="m-1 text-dark dic-title">贖い（あがない）</b-link>
              <b-collapse id="dictionary-collapse-2">
                <b-card>旧約では，⑴人手に渡った近親者の財産や土地を買い戻すこと，⑵身代金を払って奴隷を自由にすること，⑶家畜や人間の初子を神に献げる代わりに，<span class="dic-reference">いけにえ</span>を献げること，などの意味がある。旧約聖書の中で神が特に「贖い主」（イザ41：14）と呼ばれているのは，イスラエルの民を奴隷状態から解放する神の働きを述べたものである。新約では，<span class="dic-reference">キリスト</span>の死によって，人間の罪が赦され，神との正しい関係に入ることを指す。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-3 class="m-1 text-dark dic-title">悪魔（あくま）</b-link>
              <b-collapse id="dictionary-collapse-3">
                <b-card>「中傷する者」の意味で，人間を誘惑して神に反逆させる者。<span class="dic-reference">サタン</span>や<span class="dic-reference">ベリアル</span>の名で呼ばれたり，「この世の神」（2コリ4：4）という別称で呼ばれたりすることもある。なお，<span class="dic-reference">天使</span>の項参照。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-4 class="m-1 text-dark dic-title">悪霊（あくれい）</b-link>
              <b-collapse id="dictionary-collapse-4">
                <b-card>「汚れた霊」（マコ1：23）と同じで，新約聖書では精神的，肉体的病気の原因であって，人に過ちや罪を犯させる霊（マタ8：16，ルカ11：14，エフェ2：2）。
</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-5 class="m-1 text-dark dic-title">アシェラ</b-link>
              <b-collapse id="dictionary-collapse-5">
                <b-card>カナンの肥沃祭儀における女神で，ある文献によると最高神エルの配偶神。旧約では，カナンの主神<span class="dic-reference">バアル</span>がしばしば石柱で表されるのに対し，アシェラは木柱の形で礼拝される。アハブの王妃イゼベルがフェニキアから持ち込んだとされ（前850年ころ），<span class="dic-reference">預言者</span>エリヤのこれに対する戦いが有名である（王上18：16以下）。これらの礼拝所は，新共同訳では「聖なる高台」，聖書協会共同訳では<span class="dic-reference">高き所</span>と訳されている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-6 class="m-1 text-dark dic-title">アシュトレト</b-link>
              <b-collapse id="dictionary-collapse-6">
                <b-card>動植物に生命を与える豊饒，多産，愛，快楽の女神。セム族，特にティルスとシドンの民の間に流布していた（王下23：13）。<span class="dic-reference">バアル</span>の配偶神で（士2：13），堕落した祭儀を伴っていたので，聖書記者から激しく非難されている（王上11：5）。アシュトレトの裸像はパレスティナでも数多く発見されている。この女神は後代のローマのビーナスと同じような性格を持つ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-7 class="m-1 text-dark dic-title">アーメン</b-link>
              <b-collapse id="dictionary-collapse-7">
                <b-card>ヘブライ語・アラム語で「真実に」「確かに」などの意味。新約では，ギリシア語に音写されて用いられた。会話の中で相手に賛同するとき，集会で祈りに唱和するときなどに用いる（申27：15，1コリ14：16）。イエスの言葉の中には「アーメン」あるいは「アーメン，アーメン」で始まる表現が多いが，これは主として弟子たちに対する宣言の場合，特に注意を促す表現であろう。聖書協会共同訳では大体，「よく言っておく」（マタ5：18など）と訳した。また，ヨハネの黙示録3：14にはイエスの名として用いられている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-8 class="m-1 text-dark dic-title">アルファとオメガ</b-link>
              <b-collapse id="dictionary-collapse-8">
                <b-card>ギリシア語アルファベットの最初と最後の文字。ヨハネの黙示録1：8の「私はアルファであり，オメガである」という言葉は「私は初めであり，終わりである」の意味（黙21：6，22：13参照）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-9 class="m-1 text-dark dic-title">アレオパゴス</b-link>
              <b-collapse id="dictionary-collapse-9">
                <b-card>アテネのアクロポリスにある丘の名（使17：22）。そこに町の評議所があったので，この評議所のことを「アレオパゴス」と呼んだ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-10 class="m-1 text-dark dic-title">安息日（あんそくび）</b-link>
              <b-collapse id="dictionary-collapse-10">
                <b-card>週の第7日。太陽暦の金曜日日没から土曜日日没まで，モーセの<span class="dic-reference">十戒</span>によって，神を敬うために聖別された休息の日と定められていた（出20：8-11）。イエスの時代には，この日にしてはならない行為が細かく定められており，それを厳格に守ることが<span class="dic-reference">律法</span>に忠実なことの証拠とされた。<span class="dic-reference">律法学者</span>の中には，たとえば麦の穂を摘むことすら，禁じられた労働と見る者もあった（ルカ6：2）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-11 class="m-1 text-dark dic-title">イエス</b-link>
              <b-collapse id="dictionary-collapse-11">
                <b-card>ヘブライ語ヨシュア（イエシュア）のギリシア語訳。「ヤハウェ（主）は救い」という意味（マタ1：21）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-12 class="m-1 text-dark dic-title">いけにえ</b-link>
              <b-collapse id="dictionary-collapse-12">
                <b-card>ヘブライ語の動詞「屠る」（ザバハ）に由来する名詞ゼバハの訳語。イスラエルのいけにえ祭儀では，野生動物を神に献げる習慣はなく，家畜を屠って献げた。エルサレム神殿に祭儀が集中されるまでは，家畜の屠りはすべて地方聖所で行われていた（申12：14-15）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-13 class="m-1 text-dark dic-title">異言（いげん）</b-link>
              <b-collapse id="dictionary-collapse-13">
                <b-card>一般の人には理解しにくい日常言語とは別の信仰表白の言葉。コリントの信徒への手紙1の12章，14章によると，異言を語る能力は<span class="dic-reference">聖霊</span>によって与えられる「霊の賜物」（カリスマ）の一つである。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-14 class="m-1 text-dark dic-title">いと高き方（いとたかきかた）</b-link>
              <b-collapse id="dictionary-collapse-14">
                <b-card>「いと高き神（主）」と同様に，神を指すのに用いられた表現（詩7：18，9：3など）。神の名をみだりに口にしないために用いられることも多い（ルカ1：32，35，使7：48など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-15 class="m-1 text-dark dic-title">異邦人（いほうじん）</b-link>
              <b-collapse id="dictionary-collapse-15">
                <b-card>ユダヤ人以外の人。旧約では「諸国民」「異国の民」「国々」と訳されることがある。新約時代のユダヤ人は，神の約束によって特に選ばれ，その<span class="dic-reference">しるし</span>として<span class="dic-reference">律法</span>を与えられた神の民イスラエルの子孫であることを誇り，他の民族を異邦人と呼んだ。「<span class="dic-reference">割礼</span>のない者」「<span class="dic-reference">律法</span>を持たない者」なども同様の意味（マタ6：32，使15：5，ロマ2：14）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-16 class="m-1 text-dark dic-title">インマヌエル</b-link>
              <b-collapse id="dictionary-collapse-16">
                <b-card>ヘブライ語で「神我らと共に」という意味。マタイによる福音書1：23では，この語を含むイザヤ書7：14を引用して，イエスをインマヌエルと呼ぶ。その思想は，マタイによる福音書28：20「いつもあなたがたと共にいる」に至るまで貫かれている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-17 class="m-1 text-dark dic-title">「海（うみ）」</b-link>
              <b-collapse id="dictionary-collapse-17">
                <b-card>大きなたらいのようなもので，<span class="dic-reference">祭司</span>が清めの儀式に使う水を張っておいた（出30：17-21，代下4：6）。神は天地創造において天空と陸と海を創造するために地を覆っていた水を分けたが，この「海」はそれを表しているとも考えられる（創1：6-10）。この大きなたらいに付けられたさまざまな意匠は英雄神が海の怪物である「混沌」と戦うメソポタミアの創造神話に起源があるとも言われる。ヘブライ人はこの古代の物語を用いて神と悪の戦いを象徴として描いたのであろう。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-18 class="m-1 text-dark dic-title">ウリムとトンミム</b-link>
              <b-collapse id="dictionary-collapse-18">
                <b-card>神意を問う（一説によれば，呪いか潔白かを問う）ために祭司が使っていた道具と思われるが，形状は明らかではない。大祭司は盛装するとき，その二つを胸当ての中に入れていた（出28：30）。なおウリムだけ単独に記される箇所もある（民27：21など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-19 class="m-1 text-dark dic-title">永遠の命（えいえんのいのち）</b-link>
              <b-collapse id="dictionary-collapse-19">
                <b-card>聖書の教えによると，キリスト者は，身体的な命とは区別される「キリスト・イエスにある新しい命」（ロマ6：4，8：2）を受ける。これが「永遠の命」と呼ばれるもので（ヨハ3：15，16），復活されたキリスト自身の命である（ロマ8：10，11，1コリ15：45）。キリスト者は，この世に生きているときすでにこの命を持っているが（ヨハ5：24），決定的にそれに生きるのは，肉体の復活が実現する「終わりの日」を迎えるときである（ヨハ6：40，54）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-20 class="m-1 text-dark dic-title">エフォド</b-link>
              <b-collapse id="dictionary-collapse-20">
                <b-card>正確に何を指すかについては諸説があるが，幾つかの異なる物を指すと思われる。（1）神像もしくはそれに見立てた胴回り（士8：27など）。（2）神意を伺うための道具（サム上23：9-12）。（3）<span class="dic-reference">大祭司</span>が着用する祭儀用の華麗な衣服（出28：4以下，39：2）。（4）祭儀の間に<span class="dic-reference">祭司</span>たちが着用する亜麻布の簡単な衣服（サム上2：18）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-21 class="m-1 text-dark dic-title">終わりの時（おわりのとき）</b-link>
              <b-collapse id="dictionary-collapse-21">
                <b-card>旧約では，神が決定的にイスラエルの回復を図る<span class="dic-reference">メシア</span>時代を指す（ミカ4：1，ダニ8：17）。新約聖書は，<span class="dic-reference">預言者</span>たちが予告したこの時がイエスによって到来したことを告知するとともに（1コリ10：11，ヘブ1：2），「終わりの時」の完成が「世の終わり」に行われることを予告している（ヨハ6：44）。世の終わりの日は特に「裁きの日」「かの日」「主の日」と呼ばれている（マタ7：22，2テサ2：2）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-22 class="m-1 text-dark dic-title">会衆（かいしゅう）</b-link>
              <b-collapse id="dictionary-collapse-22">
                <b-card>ヘブライ語エダーの訳語で，政治，宗教的集団としてのイスラエルを構成する成人男子の公的集会を指す。また，祭儀執行の場に集合した人々を指すカハルも，本訳では「会衆」という訳語が当てられている。この両語は聖書でも厳密に区別して使用されているわけではない。なお前者のギリシア語訳には「シナゴゲー」（集い。集いの場所である<span class="dic-reference">会堂</span>もシナゴゲー，英語風に発音すればシナゴグと呼ばれている），後者には「エクレーシア」（新約では主に「教会」を指す）という訳語が当てられている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-23 class="m-1 text-dark dic-title">改宗者（かいしゅうしゃ）</b-link>
              <b-collapse id="dictionary-collapse-23">
                <b-card>新約では，一つの宗教から他の宗教に移るという一般的な意味ではなく，ユダヤ教に改宗した<span class="dic-reference">異邦人</span>を指す（マタ23：15，使2：11，13：43）。改宗して<span class="dic-reference">割礼</span>を受けるまでには至らないが，ユダヤ教を信仰している人は「神を畏れる者」と呼ばれている（使13：16，26）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-24 class="m-1 text-dark dic-title">会食のいけにえ（かいしょくのいけにえ）</b-link>
              <b-collapse id="dictionary-collapse-24">
                <b-card>「献げ物」の項を見よ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-25 class="m-1 text-dark dic-title">会堂（かいどう）</b-link>
              <b-collapse id="dictionary-collapse-25">
                <b-card>ユダヤ人の集会の場所。シナゴグ。<span class="dic-reference">安息日</span>には祈りと聖書の朗読，説教などを中心とした礼拝が行われた。また，子どもたちに<span class="dic-reference">律法</span>を教える学校，あるいは地域のユダヤ人社会の裁判所としても使用された（マタ4：23，10：17，使9：2，15：21）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-26 class="m-1 text-dark dic-title">会堂から追放された者（かいどうからついほうされたもの）</b-link>
              <b-collapse id="dictionary-collapse-26">
                <b-card>イエスの時代にはユダヤ教徒とユダヤ人キリスト者が会堂内で共存していたが（後30年前後），福音書執筆時代（後85年以降）には，会堂追放がすでに決定されていたと，ヨハネは過去完了で描写している（ヨハ9：22）。神殿崩壊（後70年）後，ヤムニアに移住し<span class="dic-reference">最高法院</span>を再興した<span class="dic-reference">ファリサイ派</span>のラビ集団は，日常朗唱する「18祈願」の12番目の「異端者への呪詛」の「ベラコーツ・ハ・ミニーム」の改訂版（破門規定）を制定し「正統と異端」を峻別し，ユダヤ民族の統合を図った。ここには，会堂内の分裂と初期キリスト教会成立の契機の史実が反映されている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-27 class="m-1 text-dark dic-title">会堂長（かいどうちょう）</b-link>
              <b-collapse id="dictionary-collapse-27">
                <b-card><span class="dic-reference">会堂</span>の礼拝をつかさどり，建物や施設の管理をする責任者（マコ5：22，ルカ13：14，使18：8）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-28 class="m-1 text-dark dic-title">割礼（かつれい）</b-link>
              <b-collapse id="dictionary-collapse-28">
                <b-card>男子の性器の包皮を切り取ること。清められたことを意味する古代オリエント諸民族の風習であったが，イスラエル民族は，神がアブラハムとその子孫を神の民とする約束のしるしとして，割礼を命じたと信じた（創17：9-14）。そのため，割礼はユダヤ共同体の一員のしるしという重要な意味を持ち，新約時代のユダヤ人男子は生後8日目に割礼を受けた（ルカ2：21，フィリ3：5）。しかし，パウロは新しい意味でのイスラエルであるキリスト教会にとって，割礼は必要な条件ではないと主張した（ロマ3：28～4：12，ガラ5：2-6参照）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-29 class="m-1 text-dark dic-title">神の国（かみのくに）</b-link>
              <b-collapse id="dictionary-collapse-29">
                <b-card>マタイによる福音書では，多くの場合「天の国」と表現。場所や領土の意味ではなく，神が王として恵みと力とをもって支配されること。イエスが来られたことによって，神の国はすでに始まっているが，やがて新しい秩序として完全に実現する（マコ1：15，9：1，ルカ17：20，21：31）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-30 class="m-1 text-dark dic-title">神の子（かみのこ）</b-link>
              <b-collapse id="dictionary-collapse-30">
                <b-card>旧約では，イスラエル全体を神の子と呼ぶ例もある（出4：22など）が，イスラエルを治める王の称号としても用いられた（詩2：7参照）。新約では「<span class="dic-reference">メシア</span>」「<span class="dic-reference">人の子</span>」などと共にイエスに対する称号として用いられており（マコ1：1，15：39），イエスと父である神との特殊な関係を指す。キリスト教徒も，これにあずかることによって神の子となる（ロマ8：14-17）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-31 class="m-1 text-dark dic-title">神の聖者（かみのせいじゃ）</b-link>
              <b-collapse id="dictionary-collapse-31">
                <b-card>マルコによる福音書1：24（ルカ4：34），ヨハネによる福音書6：69では<span class="dic-reference">キリスト</span>の称号として用いられている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-32 class="m-1 text-dark dic-title">神の霊（かみのれい）</b-link>
              <b-collapse id="dictionary-collapse-32">
                <b-card>「霊」はヘブライ語およびギリシア語で，「風」（ヨハ3：8a，ヘブ1：7），あるいは「息」（2テサ2：8）と訳されるものと同じ言葉。生命の証拠としての「息」（マタ27：50，ルカ8：55），肉体と異なる次元を意味する「霊」（1コリ5：3）などの用法がある。このように，霊は，生命そのもの，あるいは肉体とは異なる次元の人間をも意味する。しかし，本来はあくまで神から出て人間に与えられるものである（イザ42：5）。神の霊は世界を造り（創1：2，詩33：6），人間に命を授け（創2：7），戦いにおいては勝利（士14：6）を，行政においては英知（民11：17，25-29）をお与えになる。特に預言者に働きかけて神の言葉を伝え（エゼ2：2），新しい人間を再創造される（エゼ36：26）。イエスも神からこの霊を注がれ（ルカ4：18，イザ61：1），宣教活動を開始された。パウロやヨハネにおいては，「肉」と対比して用いられ，神の霊によって，新たに生まれた人間を指して「霊の人」と呼ぶこともある（1コリ3：1-3，ヨハ3：6）。「聖霊」の項を参照。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-33 class="m-1 text-dark dic-title">仮庵祭（かりいおさい）</b-link>
              <b-collapse id="dictionary-collapse-33">
                <b-card>イスラエルの三大祭り（<span class="dic-reference">除酵祭</span>，<span class="dic-reference">刈り入れの祭り</span>，仮庵祭）の一つ。ティシュリの月の15日から7日間（太陽暦の10月初旬ごろ）行われる。後代には8日間に延長された。元来は秋に行われた果実の収穫祭であった。収穫の時期，動物や盗難の被害防止を兼ねて畑に仮庵を建て，仮住まいをしたことが，エジプトを出て荒れ野を旅したときの天幕生活に重ねられて，記念祭として祝われるようになった（レビ23：34）。イエスの時代には，仮庵祭の期間中，毎日，シロアムの池の水を黄金の器に汲んで<span class="dic-reference">神殿</span>に運び，朝夕の供え物と共に祭壇に注ぐ行事が行われていたと思われる（ヨハ7：37-38）。
</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-34 class="m-1 text-dark dic-title">刈り入れの祭り（かりいれのまつり）</b-link>
              <b-collapse id="dictionary-collapse-34">
                <b-card>イスラエルの三大祭り（<span class="dic-reference">除酵祭</span>，刈り入れの祭り，<span class="dic-reference">仮庵祭</span>）の一つ。元来は，小麦の収穫を祝う春の祭りであったが，シナイ山でイスラエルに律法が授与されたことを祝う記念祭として祝われるようになった。春の最初の祭りである<span class="dic-reference">過越祭</span>から数えて七週（五十日）目に祝われたことから，「<span class="dic-reference">七週祭</span>」，あるいは，「<span class="dic-reference">五旬祭</span>（ペンテコステ）」，または単に「週の祭り」と呼ばれた。この日に<span class="dic-reference">聖霊</span>が降ったとされていることから（使2：1），キリスト教ではこれを聖霊降臨祭として祝っている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-35 class="m-1 text-dark dic-title">義（ぎ）</b-link>
              <b-collapse id="dictionary-collapse-35">
                <b-card>神の属性，また人間に対する関わりの特徴を表す概念。「神が義である」とは，神がその<span class="dic-reference">聖</span>である本性やご自分の立てた約束に誠実であり，誤謬を犯すことはありえないという意味（申32：4，詩119：137参照）。「神の義」は，人間との関わりで，不正や罪の裁きと罰における神の正しさ・公平，場合によっては救い・助け・恵み・憐れみ・勝利・繁栄などの意味を含む（士5：11，サム上12：7，エレ9：23，ヨブ36：2以下参照）。新約聖書では，神が人間にお求めになる生き方，神の裁きの基準を意味することが多い（マタ5：20，6：33，1ヨハ3：10，ヤコ1：20参照）。特にパウロ書簡では，「人間を救う神の働き」，その結果である「神と人間との正しい関係」を意味するが，<span class="dic-reference">キリスト</span>による<span class="dic-reference">贖い</span>と必然的に関連し，人間が義とされるとは，神の前で正しい者とされることであり，「救われる」とほとんど同義である（ロマ3：21-26参照）。「正しき人」の項も参照。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-36 class="m-1 text-dark dic-title">議員（ぎいん）</b-link>
              <b-collapse id="dictionary-collapse-36">
                <b-card><span class="dic-reference">最高法院</span>の議員（マコ15：43，使4：5，8）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-37 class="m-1 text-dark dic-title">奇跡（きせき）</b-link>
              <b-collapse id="dictionary-collapse-37">
                <b-card>「奇跡」「<span class="dic-reference">しるし</span>」「奇しき業」，この三つの言葉は同様の意味で，しばしば一緒に用いられている。いずれも，人間の理解を超える，驚くべき出来事を指し，神の力とその支配を表す（詩78：43，105：5，ヨハ4：48，使2：22，2コリ12：12）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-38 class="m-1 text-dark dic-title">規定の病（きていのやまい）</b-link>
              <b-collapse id="dictionary-collapse-38">
                <b-card>旧約聖書のヘブライ語「ツァラアト」，新約聖書のギリシア語「レプラ」の訳語。七十人訳ギリシア語聖書が「ツァラアト」を「レプラ」と訳し，新約聖書は「レプラ」を踏襲している。「ツァラアト」はその語源も意味も明らかでない。「ツァラアト」は祭儀的な汚れという観点から人や物について書かれている。人について用いられている場合には，何らかの皮膚の疾患を指すが，病理学的にはいかなる病気であったか明瞭ではない。レビ記13～14章に詳しい記述がある。「レプラ」も同じく祭儀的な汚れの意味で用いられ，その病の人々をイエスが清められたことが，<span class="dic-reference">奇跡</span>的な出来事として記されている（マコ1：40-45，ルカ17：11-19）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-39 class="m-1 text-dark dic-title">兄弟（きょうだい）</b-link>
              <b-collapse id="dictionary-collapse-39">
                <b-card>家族や親族，同国人など普通の意味で使われる場合もあるが（詩22：23，122：8，マタ4：18，7：3，ロマ9：3），新約聖書における最も多い用法は，<span class="dic-reference">キリスト</span>を信じる者が互いに兄弟（女性は姉妹）と呼び合って，<span class="dic-reference">会衆</span>（教会）の中の深い人格的な結び付きを表現する場合である（ロマ1：13）。今回の翻訳では，新約聖書において，明らかに男性を指す場合以外は「きょうだい」という表記を用いた。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-40 class="m-1 text-dark dic-title">清めのいけにえ（きよめのいけにえ）</b-link>
              <b-collapse id="dictionary-collapse-40">
                <b-card>「献げ物」の項を見よ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-41 class="m-1 text-dark dic-title">清めの期間（きよめのきかん）</b-link>
              <b-collapse id="dictionary-collapse-41">
                <b-card>古代イスラエルにおいては，道徳や倫理とは関係なく，「清い―汚れ」の概念が宗教生活の中心を占めていた。人々は神が忌み嫌う，汚れたものに触れたり，それを食べたりすることで，汚れて神に忌み嫌われる者となることを恐れていた。汚れは清められることを求め，それぞれの汚れに，清めを受けるまでの期間が定められていた。その期間が清めの期間と呼ばれた。例えば，産婦が男児を生んだ場合は33日，女児を生んだ場合は66日が清めの期間とされている（レビ12章）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-42 class="m-1 text-dark dic-title">キリスト</b-link>
              <b-collapse id="dictionary-collapse-42">
                <b-card>ヘブライ語の<span class="dic-reference">メシア</span>（油を注がれた者）のギリシア語訳。ペトロの信仰告白「あなたはメシア（キリスト）」（マタ16：16）のように，イエスの信仰的呼称となる（ヨハ17：3，使2：38，ロマ1：4）。なお，本訳ではギリシア語校訂本（ネストレ=アーラント『ギリシア語新約聖書（第28版）』）で「クリストス」が大文字の場合は「キリスト」，小文字の場合は「メシア」と訳出している。ただしマタ1：16とヨハ4：25は例外。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-43 class="m-1 text-dark dic-title">契約（けいやく）</b-link>
              <b-collapse id="dictionary-collapse-43">
                <b-card>この語は旧約聖書だけでも280回以上も使用され，イスラエルの宗教思想の軸となると同時に，旧約と新約とを結ぶ重要な橋渡しともなっている。そもそも「新約」とは，モーセを通して結ばれた神との契約に代わる「新しい契約」という意味だからである。古代オリエント世界においては，二つの民族，もしくは，二人の人間を最も固く結び付け，円満な関係を持たせるものが契約であると考えられていた。聖書は，人間どうしの契約について度々言及しているが（創21：25以下など），それ以上に，人間を神のものとするために神が全く自由に結ばれた契約について語っている（創9：8以下，17：1以下）。その中で最も基本的なものは，シナイ山の麓で結ばれた「シナイ契約」（出19章，24章）とダビデ王朝の永遠性を約束した「ダビデ契約」（サム下7章）である。しかし民が契約の条項（<span class="dic-reference">十戒</span>）を守らなかったので，神は「新しい契約」（エレ31：31-34）を結んで，人間との関係を正し，完成することを約束された。この約束がイエスの死によって実現され（マコ14：24，ヘブ9：15），新しい契約（新約）の時代が始まったのである。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-44 class="m-1 text-dark dic-title">契約の箱（けいやくのはこ）</b-link>
              <b-collapse id="dictionary-collapse-44">
                <b-card><span class="dic-reference">十戒</span>を刻んだ石板（証しの板）が納められた箱（申10：1-8）。従って，証しの箱とも呼ばれた。アカシヤ材で作られた長さ1.1m強，高さと幅67cmの長方形で，金で覆われていた。蓋の部分は贖いの座と呼ばれ，相対する<span class="dic-reference">ケルビム</span>が取り付けられていた（ケルビムは神の臨在の象徴であった）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-45 class="m-1 text-dark dic-title">ゲヘナ</b-link>
              <b-collapse id="dictionary-collapse-45">
                <b-card>元来は，エルサレムの南にあったヒノムの谷（ヘブライ語でゲー・ヒノム）という固有名詞に由来する（王下23：10）。その谷のトフェトという所で，モレク神へ幼児を火で焼き，献げることが行われた。これが禁止された（レビ20：2-5）後も，汚物や動物，人間の死体がそこに捨てられた。新約では，ゲー・ヒノムが，そのイメージと共に，ギリシア語でゲヘナと音写され，罪人が死後，火で焼かれて永遠の刑罰を受ける場所となり，いわゆる地獄の意味を持つに至った（マタ5：22，29，30，18：9，23：33，マコ9：43，45，ルカ12：5，ヤコ3：6など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-46 class="m-1 text-dark dic-title">ケルビム</b-link>
              <b-collapse id="dictionary-collapse-46">
                <b-card>旧約には，ヘブライ語で単数「ケルブ」，複数「ケルビム」の両方の形が記されているが，新約ではヘブライ人への手紙9：5に1回だけ，ギリシア語音写で「ケルビン」（アラム語形語尾）とある。人間の顔を持ち，翼を持った天的な動物と想像され，創世記3：24では楽園の番人，詩編18：11では神の乗り物と見なされている。<span class="dic-reference">神殿</span>の<span class="dic-reference">至聖所</span>には，<span class="dic-reference">契約の箱</span>の上に一対のケルビム像が置かれていた（王上6：23以下）。ここからして神は「ケルビムの上に座しておられる方」と呼ばれている（詩80：2）。イザヤ書6：2以下に登場するセラフィムも同じく天的な存在と考えられている。なお新共同訳／聖書協会共同訳では，単数形の場合も複数形の場合も，原則として「ケルビム」という訳語を用いた。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-47 class="m-1 text-dark dic-title">ゴグ―マゴグ</b-link>
              <b-collapse id="dictionary-collapse-47">
                <b-card>黙示文学に登場する人名（あるいは地名）。旧約のエゼキエル書では「ゴグ」は「メシェクとトバルの頭」で，「マゴグ」（地名）から出陣して主なる神に敵対するが，やがて滅ぼされる（エゼ38章以下参照）。新約ではゴグもマゴグも，<span class="dic-reference">終わりの時</span>に<span class="dic-reference">サタン</span>の手下となって戦う諸国民の名（黙20：8）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-48 class="m-1 text-dark dic-title">五旬祭（ごじゅんさい）</b-link>
              <b-collapse id="dictionary-collapse-48">
                <b-card>モーセ五書には，祝祭表が5つある（出23：14-19，34：18-26，レビ23章，民28：3～29：39，申16：1-17）。当然のことながら，後期になるに従い，祭りの数が増えており，時代によって，その名称も変化している。五旬祭は<span class="dic-reference">刈り入れの祭り</span>の別称。「刈り入れの祭り」の項を参照。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-49 class="m-1 text-dark dic-title">コヘレト</b-link>
              <b-collapse id="dictionary-collapse-49">
                <b-card>コヘレトは「集会を召集する者」，あるいは「集会の中で語る者」を意味する単語で，伝統的には「伝道者」と訳されることが多く，「コヘレトの言葉」は，新共同訳以前の日本語の聖書では「伝道の書」とか「伝道者の書」と呼ばれてきた。しかし「コヘレトの言葉」の内容はむしろ伝統的信仰を問い直そうとする性格が強く，従来の表題は内容を適切に表しているとは思われない。最近ではコヘレトを固有名詞として扱うことが一般化してきた結果，新共同訳では「コヘレトの言葉」という表題が選ばれ，聖書協会共同訳もこれを踏襲した。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-50 class="m-1 text-dark dic-title">コルバン</b-link>
              <b-collapse id="dictionary-collapse-50">
                <b-card>ヘブライ語の「献げる」に由来し，「神に献げた献げ物」を意味する。旧約では，レビ記1：2，民数記5：15など数十回用いられているが，新約では，マルコによる福音書7：11にギリシア語音写の形で記され，「つまり神への供え物なのです」という説明が付けられている。「献げ物」の項参照。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-51 class="m-1 text-dark dic-title">最高法院（さいこうほういん）</b-link>
              <b-collapse id="dictionary-collapse-51">
                <b-card>ユダヤ人の自治機関。イエスの時代には，<span class="dic-reference">大祭司</span>を議長とする71人の<span class="dic-reference">議員</span>で構成され，行政と司法の権限を持つ会議であった。ユダヤ教の<span class="dic-reference">律法</span>に関する最高法廷として，死刑を含む判決を下す権限を持っていたが，最終的にはローマ総督の裁断を仰がなければならなかった（マタ26：57～27：26，使5：17-42，22：30～23：35）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-52 class="m-1 text-dark dic-title">祭司（さいし）</b-link>
              <b-collapse id="dictionary-collapse-52">
                <b-card>神と人との仲立ちとして，祭儀をつかさどる人。旧約では，「アロンの子ら」と呼ばれ，新約では，「サドカイ」（祭司ツァドクに由来）と呼ばれている。
</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-53 class="m-1 text-dark dic-title">祭司長（さいしちょう）</b-link>
              <b-collapse id="dictionary-collapse-53">
                <b-card><span class="dic-reference">祭司</span>の長で，ギリシア語アルキエレウスが単数で用いられた場合に「<span class="dic-reference">大祭司</span>」，複数形の場合に「祭司長たち」と訳されている。複数形は以前の<span class="dic-reference">大祭司</span>（ヘロデ大王以前のハスモン家の時代には一人の終身大祭司制であった）やその家系までも含んだ数人という説がある。祭司長たちはイエスの時代の議会（<span class="dic-reference">最高法院</span>）の上層部を構成し，権力を持っていた。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-54 class="m-1 text-dark dic-title">献げ物（ささげもの）</b-link>
              <b-collapse id="dictionary-collapse-54">
                <b-card>
                  神への感謝や賛美のため，また，神の好意や赦しを得ようとして，人は神への贈り物を行ってきた。遊牧民であったヘブライ人は，最初，神への贈り物として家畜をいけにえとして献げていた。やがてカナンの地で定住生活を営むようになると，その土地で取れる収穫物をも贈り物として供えるようになった（申26：10）。<span class="dic-reference">神殿</span>が建設されると，専門的に携わる者が必要とされるようになり，祭儀は複雑化していった。レビ記1～3章では，動詞カラブ（近くする）の使役形を，奉納者が犠性獣を祭司のところへ携える行為を示す語として，あるいは，祭司がその犠牲獣を祭壇で献げる行為を示すのに用いている。そして，この同じ語から派生する名詞コルバンを神への「贈り物」全般を網羅する中心的概念としている。しかし，このような試みはレビ記の中でさえ徹底されずに終わっている。新共同訳／聖書協会共同訳は，この名詞コルバンに「献げ物」という訳語をあてた。<br>
                  イスラエルの献げ物は有血のもの（牛，羊，山羊，鳩のいけにえ）と無血のもの（穀類の供え物，ぶどう酒や香の献げ物，貴金属，宝石，土地など）とに大別できる。一般的には，それらは火で焼くことによって神へと届けられたが，主の前に献納物や奉献物として供えられた後，祭司の取り分，あるいは神殿のために使用されることで，神のものとされた。火による献げ物は，いけにえの肉も脂肪もすべてを焼いて神に献げる場合（焼き尽くすいけにえ）と，脂肪のみを神に献げる場合（会食のいけにえ）の二つのやり方で行われた。この火による献げ物は，その意向や目的によって，償いのいけにえ，清めのいけにえ，誓願の献げ物や任職の献げ物，感謝の献げ物などと称されることになる。<br>
                  なお，聖書協会共同訳におけるこの種の訳語に対応する新共同訳聖書の訳語を，それぞれ括弧内に示せば，次のとおりである。<br>
                  <ul class="ml-4">
                    <li>焼き尽くすいけにえ（焼き尽くす献げ物）</li>
                    <li>会食のいけにえ（和解の献げ物）</li>
                    <li>火による献げ物（燃やして献げる宥めの香）</li>
                    <li>清めのいけにえ（贖罪の献げ物）</li>
                    <li>償いのいけにえ（賠償の献げ物）</li>
                    <li>穀物の供え物（穀物の献げ物）</li>
                    <li>注ぎの供え物（ぶどう酒の献げ物）</li>
                    <li>自発の献げ物（随意の献げ物）</li>
                    <li>誓願の献げ物（満願の献げ物）</li>
                    <li>感謝の献げ物（感謝の献げ物）</li>
                  </ul>
                </b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-55 class="m-1 text-dark dic-title">サタン</b-link>
              <b-collapse id="dictionary-collapse-55">
                <b-card><span class="dic-reference">悪魔</span>と同じ意味。元の意味は「中傷する者」「訴える者」。旧約では，人間の罪を神に告発する者といった意味の普通名詞であったが（ヨブ1：6），後に悪魔の名となった。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-56 class="m-1 text-dark dic-title">サドカイ派（サドカイは）</b-link>
              <b-collapse id="dictionary-collapse-56">
                  <b-card><span class="dic-reference">ファリサイ派</span>と共にイエスの時代のユダヤ教の一派で，祖先はダビデの時代の<span class="dic-reference">祭司</span>ツァドクの家系と思われる。大半は指導的な<span class="dic-reference">祭司</span>や社会的特権階級の者で，成文の<span class="dic-reference">律法</span>，モーセ五書のみを認め，復活，<span class="dic-reference">天使</span>，霊を認めなかった（使23：8）。民衆からの支持が少なく，後70年のエルサレム<span class="dic-reference">神殿</span>崩壊とともに歴史の舞台から姿を消す。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-57 class="m-1 text-dark dic-title">サマリア人（サマリアじん）</b-link>
              <b-collapse id="dictionary-collapse-57">
                <b-card>ユダヤ教に対抗して特別な教派を形成していた，サマリア地方の人々を指す。前721年アッシリアの王サルゴン2世によるサマリア攻略後，アッシリアの各地から集められた人々がサマリアに移住し，自分たちの宗教とユダヤ教とを混交したものを信じた（王下17：24-34）。その後彼らは，ゲリジム山に自分たちの<span class="dic-reference">神殿</span>を建てた。そのことからユダヤ人はサマリア人を正統信仰から離れたものと見なし（ヨハ8：48参照），交わりを絶っていた（ヨハ4：9）。福音書にもしばしば現れ（ヨハ4：39-42，ルカ9：52，53，10：33，17：16），使徒言行録の中では彼らがイエスの福音を受け入れた様が語られている（使8：5-25）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-58 class="m-1 text-dark dic-title">シェフェラ</b-link>
              <b-collapse id="dictionary-collapse-58">
                <b-card>沿岸地帯とユダの山地の間，あるいは，沿岸地帯とサマリア，カルメル山脈の間にある低地を指す（申1：7など）。雨量の多い，肥沃な地域で，穀物，オリーブ，ぶどうを産出した。さまざまな戦闘の舞台ともなった。口語訳では「平地」と訳された。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-59 class="m-1 text-dark dic-title">シオン</b-link>
              <b-collapse id="dictionary-collapse-59">
                <b-card>本来はエルサレムの東南部の丘の名であるが，後には<span class="dic-reference">神殿</span>あるいはエルサレム全体を指す名称となった。また，神の都エルサレムおよびその住民という意味もあった（マタ21：5，ヨハ12：15，ヘブ12：22，黙14：1）。旧約では「シオンに住まわれる神」に対する愛情が表されており（詩48：3など），エルサレムの住民は「シオンの娘」と呼ばれることもある（イザ3：16）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-60 class="m-1 text-dark dic-title">士師（しし）</b-link>
              <b-collapse id="dictionary-collapse-60">
                <b-card>本来は「裁く」という動詞の分詞形であり，「裁き人」を意味する。カナン占領から王国成立までの期間，2種類の士師が登場する。争い事を調停する職務を担っていた裁き人6人（士10：1-5，12：7-15）と，敵が攻めて来たときに神の霊が注がれて軍事的な指導をした者6人である（デボラ，ギデオン，サムソンなど）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-61 class="m-1 text-dark dic-title">至聖所（しせいじょ）</b-link>
              <b-collapse id="dictionary-collapse-61">
                <b-card>「聖の聖」，つまり最も神聖な場所の意味で，<span class="dic-reference">神殿</span>の一番奥の間を指す。そこには，2体の<span class="dic-reference">ケルビム</span>の像と<span class="dic-reference">契約の箱</span>とが置かれていた（出25：18-22，王上6：19，23-28）。聖所との間は幕で仕切られており，<span class="dic-reference">大祭司</span>が年に一度贖いの日に入るほかは，誰も入ることが許されない場所とされた（レビ16章，ヘブ9：7）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-62 class="m-1 text-dark dic-title">自然の人（しぜんのひと）</b-link>
              <b-collapse id="dictionary-collapse-62">
                <b-card>パウロの手紙の中では，「<span class="dic-reference">肉</span>」あるいは「肉の人」（1コリ3：3）と同じ意味に使われる。この世に生まれた人間は，そのままでは罪に支配されていて，神との正しい関係を持つことができない（1コリ2：14）。「神の霊」の項参照。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-63 class="m-1 text-dark dic-title">十戒（じっかい）</b-link>
              <b-collapse id="dictionary-collapse-63">
                <b-card>原語では「十の言葉」（出34：28「（モーセは）板の上に契約の言葉，十の言葉を書き記した」）。出エジプト記20章と申命記5章に，そのテキストが載っている｡「十戒」の前半部分では神と人との関係が規定され，後半部分では社会的な規定が述べられている｡各規定は均一な文体ではなく，第四戒と第五戒は肯定命令，他は禁止命令になっている。この禁止命令は「あなたは…しないであろう」という神の期待ないし，希望として訳すことも可能で，十戒は神から課された掟というより，むしろ，神の信頼のもとに授けられた使命として理解することができる。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-64 class="m-1 text-dark dic-title">使徒（しと）</b-link>
              <b-collapse id="dictionary-collapse-64">
                <b-card>イエスが弟子の中からお選びになった「<span class="dic-reference">十二人</span>」。イエスの復活の後は，教会の最高の職位として宣教の責任を持つ者を意味した。本来の語義は「使者」（マタ10：2，ルカ6：13，1コリ1：1，15：7-11，エフェ4：11）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-65 class="m-1 text-dark dic-title">「柴」の箇所（しばのかしょ）</b-link>
              <b-collapse id="dictionary-collapse-65">
                <b-card>出エジプト記3章の，神が燃える柴の中からモーセに語られた記事を指す（マコ12：26，ルカ20：37）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-66 class="m-1 text-dark dic-title">主（しゅ）</b-link>
              <b-collapse id="dictionary-collapse-66">
                <b-card>
                    旧約聖書中，イスラエルの神は種々の名称で呼ばれており，そのうち最も多いのがいわゆる神聖四文字YHWH（6500回以上）である。この語の正確な読み方は分からないが一般にヤーウェまたヤハウェ（文語訳ではエホバ）と表記されている。この神名は人名の末尾に「ヤ」という短い形で付加されることが多い（「イザヤ，エレミヤ」など）。「YHWH」という名前の意味について聖書にはさまざまの暗示が見いだされるが，空虚な神々とは違って実際に「存在する者」，行動的に人々と共にいて，彼らに援助を与え，「現存する者」という意味が最も重要であると思われる。後になると，神に対する畏敬のゆえに，この名は口にされなくなった。その代わりに神聖四文字は「アドナイ（主）」と読まれるようになり，この読み方が七十人訳のギリシア語聖書にも導入されて「キュリオス（主）」と訳された。<span class="dic-reference">使徒</span>たちは，特に，復活して父の右に挙げられたイエスを指すためにこの「主」という称号を使用した（フィリ2：11など）。なお，<span class="dic-reference">預言者</span>が度々用いる「万軍の主」という呼称は，森羅万象，特に天の軍隊と考えられていた星辰を統べ治める全能の神を表している。<br>
                    なお，ヘブライ語原文で「アドナイ・ヤハウェ」と記されている所は，本訳では「主なる主」ではなく，ユダヤ教での朗読（アドナイ・エロヒム）のように，「（わが）主なる神」と訳されている（イザ3：15など）。一方，原文でヤハウェ・エロヒムと記されている所は主に「神である主」と訳されている（創2：4など）。
                </b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-67 class="m-1 text-dark dic-title">十二人（じゅうににん）</b-link>
              <b-collapse id="dictionary-collapse-67">
                <b-card>イエスの弟子のうち，イスラエルの<span class="dic-reference">十二部族</span>の数にちなんで特に選ばれた側近の12人。「十二人の弟子」「十二使徒」と同じ意味だが，「弟子」とか「<span class="dic-reference">使徒</span>」を付けない場合が多い（マタ10：5，マコ6：7，14：17など）。イスカリオテのユダが抜けた後，マティアを加えて再び12人とした（マタ28：16，使1：26参照）。なお使徒言行録2：14の「十一人」は，ペトロ以外の<span class="dic-reference">使徒</span>を指す。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-68 class="m-1 text-dark dic-title">十二部族（じゅうにぶぞく）</b-link>
              <b-collapse id="dictionary-collapse-68">
                <b-card>イスラエル民族はヤコブの<span class="dic-reference">12人</span>の子を祖先とする12の部族から成っていた（ただし，神殿に仕えるレビ族を含めず，代わりにヨセフの子マナセとエフライムをそれぞれ一つの部族とする数え方もある）。イエスはそのうちの一つ，ユダ族の出身であられた（ヘブ7：14）。新約では，「十二使徒」を指導者とする教会が，神の民として新しい意味のイスラエルとなる（マタ19：28，ヤコ1：1，黙21：12-14）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-69 class="m-1 text-dark dic-title">主の日（しゅのひ）</b-link>
              <b-collapse id="dictionary-collapse-69">
                <b-card>旧約では，神が裁きを行われる終末の日。この日，神は正しい人には救いを，悪人には滅びをもたらす（アモ5：18，ゼファ1：7）。新約では，世の終わり（<span class="dic-reference">終わりの時</span>）に，<span class="dic-reference">キリスト</span>が来臨される時を意味する（1コリ5：5，2コリ1：14，1テサ5：2）。ほかに，イエスの復活した日という意味で日曜日を指す場合もある（黙1：10）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-70 class="m-1 text-dark dic-title">主は生きておられる（しゅはいきておられる）</b-link>
              <b-collapse id="dictionary-collapse-70">
                <b-card>士師記8：19，サムエル記上14：39，45などに見られる「誓い」という意味を表す定まった言い方。「生ける主にかけて誓う」の意。神ご自身が語られる場合には，「私は生きている」（民14：21，28，イザ49：18，エレ22：24など参照）となる。人間の命にかけて誓うこともある（サム上1：26，サム下14：19など）。また，神と人間の両者の命にかけて誓う場合も見られる（王下2：2，4，6，4：30など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-71 class="m-1 text-dark dic-title">準備の日（じゅんびのひ）</b-link>
              <b-collapse id="dictionary-collapse-71">
                <b-card>週の第6日，今の金曜日に当たる。<span class="dic-reference">安息日</span>の前日。<span class="dic-reference">安息日</span>を守るための準備をする日という意味で，この名称がある。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-72 class="m-1 text-dark dic-title">除酵祭（じょこうさい）</b-link>
              <b-collapse id="dictionary-collapse-72">
                <b-card>エジプト脱出を記念して，パン種を入れないパンを七日間食べたことに由来する名称。「第一の月の十四日の夕暮れに主の過越祭，その月の十五日から主の除酵祭である」（レビ23：5-6）。元来は，大麦の収穫祭であったが，祝われる日がほぼ同じであったことから，次第に<span class="dic-reference">過越祭</span>の別名となった（マタ26：17）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-73 class="m-1 text-dark dic-title">しるし</b-link>
              <b-collapse id="dictionary-collapse-73">
                <b-card>「奇跡」の項を見よ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-74 class="m-1 text-dark dic-title">深淵（しんえん）</b-link>
              <b-collapse id="dictionary-collapse-74">
                <b-card>旧約ではヘブライ語のテホムは「深淵」と訳されるが，海の深み，原始の海と訳すこともできる。これは，創造以前に地を覆っていたが（創1：2），創造の二日目に天の海と地の海とに分けられた。そのため，旧約では混沌としたものの象徴として理解される（創7：11，出15：5，エゼ26：19）。新約ではアビュッソスが<span class="dic-reference">陰府</span>を指し示す表現として用いられる（ルカ8：31，ロマ10：7）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-75 class="m-1 text-dark dic-title">神殿（しんでん）</b-link>
              <b-collapse id="dictionary-collapse-75">
                <b-card>イスラエル民族がカナンに定着して後，いくつかの聖所が存在していたが，ソロモン王の治世に，イスラエルの礼拝・祭儀の中心の場としてエルサレムに神殿が建造された（王上5～7章参照）。この神殿はバビロニア王ネブカドネツァル（＝ネブカドレツァル）に破壊されたが，その後，バビロン<span class="dic-reference">捕囚</span>から帰還した人々の手で再建された（エズ5：6～6：12）。前20年ごろ，ヘロデ大王は神殿の大規模な修理拡張工事を始め，イエスの時代には，周囲に回廊を巡らした広い境内と，白い大理石の美しい本殿を持つ立派な建造物となっていた（マタ24：1，マコ13：1，2，ヨハ2：20参照）。新約における神殿とは，ほとんどすべての場合，このエルサレムの神殿を指すが（使19：24にあるエフェソの女神アルテミスの神殿などは例外），後70年にローマ軍によって破壊された。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-76 class="m-1 text-dark dic-title">神殿税（しんでんぜい）</b-link>
              <b-collapse id="dictionary-collapse-76">
                <b-card>出エジプト記30：11以下に定められた規定に従って，ユダヤ人成人男子が年に一度，<span class="dic-reference">神殿</span>に納める税金。額は旧約では半シェケル，新約時代には2ドラクメであった（マタ17：24以下）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-77 class="m-1 text-dark dic-title">過越祭（すぎこしさい）</b-link>
              <b-collapse id="dictionary-collapse-77">
                <b-card>イスラエルの三大祭りの一つで，イスラエルの民がエジプトから救い出されたことを祝う祭り。祭りの名称は，エジプト人の長子と家畜の初子を滅ぼす神の使いが，イスラエル人の家を「過ぎ越し」たことに由来している（出12：23-27）。収穫祭とは異なる特徴を示しているので，遊牧民であった時代に溯りうる祭りと考えられている。ニサンの月の14日（太陽暦では3月末から4月初め頃）に小羊を屠って焼き，種なしパンと共に食して祝った。イスラエル人の信仰の根源をなすエジプト脱出を祝うので，この祭りを忠実に祝うよう聖書記者は強調している（出12：24，王下23：21，エズ6：19-22）。<span class="dic-reference">キリスト</span>も受難の前夜これを祝われた（ルカ22：16）。初代教会は，<span class="dic-reference">キリスト</span>自身をこの犠牲の小羊と見なし（1コリ5：7），神の民の死から生命への過越を祝った。キリスト教会では，春分の日を過ぎた，満月の後に来る日曜日をイエスの復活祭としている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-78 class="m-1 text-dark dic-title">救い主（すくいぬし）</b-link>
              <b-collapse id="dictionary-collapse-78">
                <b-card>ギリシア語でソーテール。旧約聖書のギリシア語訳，七十人訳聖書では，この語は人に対しても（士3：9など），神に対しても（イザ17：10など）多く用いられている。新約聖書ではこの言葉は意外に少ない（10回）。神に対して（ルカ1：47，一テモ4：10，ユダ1：25），しかし主にイエスに対する信仰告白としての称号として用いられる（ルカ2：11，ヨハ4：42，使5：31，エフェ5：23など）。そこには，当時この言葉が，すでにローマ皇帝アウグストゥスに対する尊称として用いられていたことへの対抗意識もあると考えられる。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-79 class="m-1 text-dark dic-title">隅の親石（すみのおやいし）</b-link>
              <b-collapse id="dictionary-collapse-79">
                <b-card>石造建築で最後に隅に置く押さえの石。詩編118：22が出典で，新約にたびたび引用される（マタ21：42，マコ12：10，ルカ20：17，使4：11，1ペト2：7，旧約では詩118：22，ゼカ4：7）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-80 class="m-1 text-dark dic-title">聖（せい）</b-link>
              <b-collapse id="dictionary-collapse-80">
                <b-card>神の絶対的な尊厳を表す表現。人間を含むあらゆる被造物との隔たりを意味する。<span class="dic-reference">預言者</span>イザヤは，召命を受けたとき，神の聖性をたたえる<span class="dic-reference">天使</span>の力強い宣言を聞いている（イザ6：3）。さらに，この語は神に属する事物や人間に適用される。聖所，「聖なる人たち」などは，それ自身が聖であるというよりも，神のものとして清められたという意味で聖である。使徒パウロは，キリスト信者をこの意味で「聖なる者」と呼んでいる（ロマ1：7など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-81 class="m-1 text-dark dic-title">聖霊（せいれい）</b-link>
              <b-collapse id="dictionary-collapse-81">
                <b-card><span class="dic-reference">神の霊</span>の別名。特に新約聖書においてこの表現は頻繁に用いられ，重要な事柄を表している。イエスは聖霊によって身ごもったマリアからお生まれになり（マタ1：18，20，ルカ1：35），ヨルダン川で洗礼を受けたときに，聖霊がイエスの上にお降りになった（ルカ3：22）。復活したイエスが約束されたとおり，聖霊は五旬祭の日，イエスの弟子たちの上に降って（使2：1-4），教会が生まれた。パウロによれば，イエスの死と復活によって私たちに与えられる最大の賜物は聖霊であり，「私たちに与えられた聖霊によって，神の愛が私たちの心に注がれている」（ロマ5：5）。また，聖霊は「<span class="dic-reference">弁護者</span>」と呼ばれ，いつまでも弟子たちと共にいてイエスを証しし，弟子をあらゆる真理に導いてくださる（ヨハ14：26，15：26，16：13）。キリスト教の<span class="dic-reference">洗礼</span>はイエスの命令どおりに，「父と子と聖霊の名によって」授けられるが（マタ28：19），ここに初代教会の信条にも表されている，キリスト教の根本的な神理解が示されている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-82 class="m-1 text-dark dic-title">全能者（ぜんのうしゃ）</b-link>
              <b-collapse id="dictionary-collapse-82">
                <b-card>原語は，「シャダイ」または「エル・シャダイ」で，これはイスラエルの神の古い名称の一つである。「山に住む神」（山は神の住居と考えられていた）を意味していると言われているが，明らかではない。シャダイは「全能者」，エル・シャダイは「全能の神」と訳されている。これらの語は，七十人訳ギリシア語聖書では「全能者（パントクラトール）」と訳され，新約のヨハネの黙示録でもその呼び方が使われている（1：8以下9回）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-83 class="m-1 text-dark dic-title">洗礼〔バプテスマ〕（せんれい）</b-link>
              <b-collapse id="dictionary-collapse-83">
                <b-card>従来のプロテスタント諸訳では「バプテスマ」と訳されていたが，これはギリシア語「バプティスマ」（名詞形）の音訳。動詞形「バプティゾー」は元来「水に浸す」という意味。ヨハネは「悔い改めの洗礼」を授けた（マタ3：7）が，ユダヤ教の一部では，宗教的な清めの儀式として，身を水に浸すことが行われていた。キリスト教では，罪からの清めと，<span class="dic-reference">キリスト</span>と一致する新しい生活に入るしるしとなり，教会の重要な聖礼典もしくは秘跡となった（使8：36，9：18，ロマ6：3，4，ガラ3：27）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-84 class="m-1 text-dark dic-title">相続地（そうぞくち），所有の民（しょゆうのたみ）</b-link>
              <b-collapse id="dictionary-collapse-84">
                <b-card>ヘブライ語で「ナハル」「ナハラ」。本来は「賜物」を意味し，資産，相続財産，特に相続地を指す。神はカナンの地をアブラハムとその子孫に与えると約束し，それを果たしたので（創15：18-21），土地は個人の所有物ではなく，神の所有地として家に属するものとなった。こうしてイスラエルでは，相続やその確保について詳しい規定が設けられた（民27：1-11）。新共同訳では「嗣業」と訳されていたが，本訳では，「相続地」，「所有の民」など，幾つかの訳語に訳し分けられている。この概念はさらに発展して，イスラエルの民自身が神のものとなり（申32：9），一方，神ご自身がその民の相続地となると考えられるようになった（詩16：5，6）。新約では，地上の事物ではなく，「神の国そのものを受け継ぐ」ことが神の最大の祝福と見なされている（マタ25：34）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-85 class="m-1 text-dark dic-title">族長（ぞくちょう）</b-link>
              <b-collapse id="dictionary-collapse-85">
                <b-card>イスラエル民族の祖先。アブラハム，イサク，ヤコブを指す。ヤコブの12人の息子がイスラエルの<span class="dic-reference">十二部族</span>の祖となった。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-86 class="m-1 text-dark dic-title">大祭司（だいさいし）</b-link>
              <b-collapse id="dictionary-collapse-86">
                <b-card><span class="dic-reference">祭司</span>の最高の職位。新約時代には同時に<span class="dic-reference">最高法院</span>の長でもあった。大祭司は1年に一度，贖いの日に自分自身とイスラエルの民全体のために，<span class="dic-reference">いけにえ</span>として献げられた雄牛の血を皿に入れて<span class="dic-reference">神殿</span>の<span class="dic-reference">至聖所</span>に入り，そこでその血を注いだ。（レビ16：11-34，ヘブ9：7）。<span class="dic-reference">祭司</span>の家系から選ばれ，終身の職位であったが，ヘロデ時代以後はこの制度が乱れ，権力者の意のままに任免が行われた。ヘブライ人への手紙は，イエスの大祭司職について詳述している。「祭司長」の項参照。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-87 class="m-1 text-dark dic-title">高き所（たかきところ）</b-link>
              <b-collapse id="dictionary-collapse-87">
                <b-card>高台を意味するカナン人の礼拝所。聖木（<span class="dic-reference">アシェラ</span>）や石柱があり，建物と祭壇が付属していた。初期には丘の上に設けられていたが，後には大木の下（エゼ6：13），人工の高台にも設けられた。メギドやハツォルに遺跡が発見されている。イスラエルは「高き所」を利用していたが（サム上9：12，王上3：4），<span class="dic-reference">神殿</span>が建てられ，ヨシヤ王がすべての<span class="dic-reference">献げ物</span>をエルサレムの神殿でのみ，献げるように命じてからは，その利用を禁止した（王下23：5）。しかしながら一掃することはできなかった（エレ19：5）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-88 class="m-1 text-dark dic-title">正しき人（ただしきひと）</b-link>
              <b-collapse id="dictionary-collapse-88">
                <b-card>神との正しい関係にある人間。聖書で「<span class="dic-reference">義</span>」あるいは「正しき」，「正しい」と訳されたヘブライ語ツァディクは，本来，神について用いられ，単に道徳的・社会的正義といった価値を意味するものではない。神は正しい神であり，人間にも正しさを要求される。しかし，人間はその要求に背いて神との正しい関係から外れ，人間の力だけでは，これを回復しえなくなった。<span class="dic-reference">預言者</span>たちは，これが来るべき<span class="dic-reference">救い主</span>（<span class="dic-reference">メシア</span>）によって実現されると教えた（イザ53：11）。人間が正しい者とされるのは，神の救いの働きにより，<span class="dic-reference">キリスト</span>を信じる信仰によるので，世界のすべての人がその恵みにあずかることができるようになった（ロマ5：18）。「義」の項参照。なお，ヤシャルと区別するために，ツァディクは主に「正しき人」，ヤシャルは主に「正しい人」と訳し分けている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-89 class="m-1 text-dark dic-title">ダビデの子（ダビデのこ）</b-link>
              <b-collapse id="dictionary-collapse-89">
                <b-card>旧約では王ダビデの子孫から<span class="dic-reference">メシア</span>が出るという信仰（サム下7：12，13）に基づく<span class="dic-reference">メシア</span>の称号。新約では専ら<span class="dic-reference">キリスト</span>，イエスを指す（マタ1：1など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-90 class="m-1 text-dark dic-title">断食（だんじき）</b-link>
              <b-collapse id="dictionary-collapse-90">
                <b-card>宗教的な動機で一定の期間，食事を断つこと。旧約の時代からすでに実践され（申9：18），新約の時代に及んでいる（使13：2，3）。イエスも宣教を開始するにあたり，40日間の断食を荒れ野でなさった（マタ4：2）。罪を悔やむ行為としては，断食のほかに，粗布（あらぬの）をまとったり（詩35：13），頭に灰をかぶったりした（エス4：1）。使徒言行録27：9にある「断食日」は「贖いの日」と同じ日であると思われる。この日はティシュリの月の10日（太陽暦の9-10月）で，<span class="dic-reference">大祭司</span>はこの日に<span class="dic-reference">至聖所</span>に入り，全国民が罪の懺悔のために断食をする定めになっていた。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-91 class="m-1 text-dark dic-title">知識（ちしき）</b-link>
              <b-collapse id="dictionary-collapse-91">
                <b-card>
                    旧約の民は「神を知る」ことを重要視した（詩100：3）。これは思弁的に神を知ることではなく，恵みを与え裁きを行う方としての神を認めて，これに仕え，これと生きた交わりを結ぶことである（エレ9：1-5）。これに反し，人間の犯す一切の悪は神を知らないことから起こり，これによって正しい人間関係も社会生活も破壊されてしまう（ホセ4：1，2）。<span class="dic-reference">預言者</span>たちは<span class="dic-reference">メシア</span>時代になると，神を知る新しい知識が地上に満ち（イザ11：9），人間は「新しい心」（エゼ36：26，27）で神を知るようになると預言している。またイスラエルには古い時代から「知者」と呼ばれる人々がいて，建築，農業などの実際的技能を教え，王の外交，裁判，行政を助け，さらに人生の生き方を教えていた。<br>
                    新約では，特に霊的な真理の知識，神を知ること，などの意味で用いられる（ルカ11：52，1コリ8章，コロ2：3）。他方，テモテへの手紙1の6：20の「知識」は，当時のグノーシス（知識）主義を指すものと思われる。グノーシス主義とは，一般の人には隠された真理が，特定の人に啓示されていると主張する一種の宗教哲学で，キリスト教にも影響を与えた。ヨハネの手紙などもグノーシス主義の異端を戒めて，真の「知識」を説いている（1ヨハ2：3，4など）。
                </b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-92 class="m-1 text-dark dic-title">仲介者（ちゅうかいしゃ）</b-link>
              <b-collapse id="dictionary-collapse-92">
                <b-card>神と人間との間に立って，和解の仲立ちをする者。旧約では，モーセが神とイスラエルの<span class="dic-reference">契約</span>の仲介者と言われたが，新約では，<span class="dic-reference">キリスト</span>が新しい<span class="dic-reference">契約</span>の唯一の仲介者であられる（1テモ2：5，ヘブ8：6，9：15）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-93 class="m-1 text-dark dic-title">徴税人（ちょうぜいにん）</b-link>
              <b-collapse id="dictionary-collapse-93">
                <b-card>ローマ政府あるいは領主（ガリラヤではヘロデ・アンティパス）から税金の取り立てを委託された者。<span class="dic-reference">異邦人</span>である外国の支配者のために働くばかりでなく，割り当てられた税額以上の金を取り立てて私腹を肥やすという理由で，ユダヤ人から憎まれ，「<span class="dic-reference">罪人</span>」と同様に見なされていた。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-94 class="m-1 text-dark dic-title">長老（ちょうろう）</b-link>
              <b-collapse id="dictionary-collapse-94">
                <b-card>イスラエルの部族制度の中で，家族，氏族，部族を代表し，それを取り仕切る任務を帯びていた（出3：16，民11：16）。一般に年輩者だったので，「長老」（「老人」の意）と呼ばれたが，年齢よりもむしろ高い身分を指している。後には王の顧問の術語となり（王上12：6など。100回以上），マカバイ時代以後は，国の<span class="dic-reference">最高法院</span>の<span class="dic-reference">議員</span>の一部を指すようになった（マタ21：23，26：3）。長老制は新約の教会にも取り入れられ，指導的地位とされた（使14：23，1テモ5：17）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-95 class="m-1 text-dark dic-title">償いのいけにえ（つぐないのいけにえ）</b-link>
              <b-collapse id="dictionary-collapse-95">
                <b-card>「献げ物」の項を見よ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-96 class="m-1 text-dark dic-title">角（つの）</b-link>
              <b-collapse id="dictionary-collapse-96">
                <b-card>元来は動物の角を指す。これは角笛として楽器とされ（ヨシュ6：4，詩150：3など），油や化粧料の容器としても使われた（サム上16：1）。さらに角は「力」のシンボルと見なされ，「角を上げる」（詩89：18），「救いの角」（詩18：3）などの表現が生まれた。その他，祭壇の四隅に付けられた突起も「角」と呼んだ（出27：2）。<span class="dic-reference">献げ物</span>にされた動物の血がその上に塗られ（レビ4：7），それにつかまると，過って人を殺した場合でも死を免れることができた（王上1：50，2：28。「逃れの町」の項参照）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-97 class="m-1 text-dark dic-title">罪人（つみびと）</b-link>
              <b-collapse id="dictionary-collapse-97">
                <b-card>神に背き，その<span class="dic-reference">律法</span>を犯す者。「悪人」と同義。しかし福音書では<span class="dic-reference">律法学者</span>や，<span class="dic-reference">ファリサイ派</span>から，日常の生活で<span class="dic-reference">律法</span>を忠実に守らないという理由で批判された人々を指す。<span class="dic-reference">徴税人</span>や娼婦などは典型的な罪人であった（マタ21：31，マコ2：16）。パウロは，人間はすべて「罪人」であって，「<span class="dic-reference">律法</span>」を守ることができず，ただ<span class="dic-reference">キリスト</span>の真実によって罪から解放され，「命の霊」を受けて，それに従って歩み，律法の要求を満たしていると説いている（ロマ3：5-26）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-98 class="m-1 text-dark dic-title">天（てん）</b-link>
              <b-collapse id="dictionary-collapse-98">
                <b-card>聖書では，「天」は物理的空間，もしくは，神の住まいを指す。旧約の宇宙観では，天は金属の延べ板を張った天井のようなもので，その上には「上の水」が蓄えられており（創1：6，7），地上に降る雨や雪を通す「天の窓」が付いている（創7：11）。また太陽，月，星も天井の内側に敷かれている軌道の上を動く（詩8：4，19：6-7）。一方，人の上に高くある天は，神が<span class="dic-reference">天使</span>に奉仕されながら王座に着いている住まいとも考えられており（ダニ7：9，13），神の超越性，尊厳性，不変性を表す。イエスは，「天におられる父」（マタ6：9）について語り，十字架を通して「天に上げられ」（使1：9），（神が）「地にあるものも，天にあるものも，万物を御子によってご自分と和解させてくださった」（コロ1：20）。それでキリスト者の「国籍」（フィリ3：20）と「故郷」（ヘブ11：14-16）は天にあり，彼らは「新しい天と新しい地」を待ち望みながら（黙21：1，2ペト3：13），「天の召し」にふさわしく生活する（ヘブ3：1）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-99 class="m-1 text-dark dic-title">天使（てんし）</b-link>
              <b-collapse id="dictionary-collapse-99">
                <b-card>神から遣わされる使者で，天上では神に仕え，地上では特定の人間に現れて，神の意志を伝え，人間を守護し導いた（マタ1：20，2：13，19，ルカ2：10-12など）。旧約・新約には天使「ガブリエル」「ミカエル」が登場するが，続編にはラファエル，エレミエル，ウリエルの名もある。新約では<span class="dic-reference">悪魔</span>も堕落した天使と信じられている（2ペト2：4，黙12：7-12）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-100 class="m-1 text-dark dic-title">天の国（てんのくに）</b-link>
              <b-collapse id="dictionary-collapse-100">
                <b-card>「神の国」の項を見よ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-101 class="m-1 text-dark dic-title">ナザレ人の分派（ナザレじんのぶんぱ）</b-link>
              <b-collapse id="dictionary-collapse-101">
                <b-card>ナザレ出身の者（イエス）を指導者とするユダヤ教の分派という意味で，ユダヤ人が初代キリスト教徒を敵視して呼んだ名称（使24：5）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-102 class="m-1 text-dark dic-title">ナジル人（ナジルびと）</b-link>
              <b-collapse id="dictionary-collapse-102">
                <b-card>ナジルはヘブライ語の動詞ナザル（聖別する）に由来する語で，誓願を立てて自らを聖別した人を意味する。その誓願中は，酒を断ち，頭髪を刈らず，死体に触れなかった（民6：1-21）。しかしサムソン（士13章）や<span class="dic-reference">預言者</span>サムエル（サム上1：28）のように，母親によって神に献げられ，生涯ナジル人とされた者もいる。新約では，洗礼者ヨハネがそのような生活を送っており（ルカ1：15），使徒パウロもそのような誓願を立てている（使18：18）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-103 class="m-1 text-dark dic-title">七週祭（ななしゅうさい）</b-link>
              <b-collapse id="dictionary-collapse-103">
                <b-card>「刈り入れの祭り」の項を見よ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-104 class="m-1 text-dark dic-title">肉（にく）</b-link>
              <b-collapse id="dictionary-collapse-104">
                <b-card>旧約では，通常の意味で用いる場合もあるが，夫婦や親子のような近親関係にある者（創2：23，サム下5：1），さらには，死すべき弱さをまとった者としての人間を意味することがある（創6：3，詩78：39）。また，霊に対立する意味でも使われている。パウロの手紙やヨハネによる福音書では，霊によって新たに生まれないかぎり，人間は「肉の人」「<span class="dic-reference">自然の人</span>」であって，罪によって滅びる存在である（1コリ2：14，3：1-3，ヨハ3：6）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-105 class="m-1 text-dark dic-title">ニコライ派（ニコライは）</b-link>
              <b-collapse id="dictionary-collapse-105">
                <b-card>ヨハネの黙示録2：6，15によれば，エフェソとペルガモンの教会に影響を与えた分派。キリスト者はこの世を超越しているのだから，偶像に供えた肉を食べることや，淫らな行いなどの禁止をことさらに守らなくてもよいと唱えた。アンティオキア出身のニコラオ（使6：5）を始祖と考える説もある。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-106 class="m-1 text-dark dic-title">妬む神（ねたむかみ）</b-link>
              <b-collapse id="dictionary-collapse-106">
                <b-card>神の呼称の一つ（出20：5，申4：24，ナホ1：2など）。神は<span class="dic-reference">契約</span>によってイスラエルを自分の民とされたので，これを深く愛し，民が神に背いたときには罰を加えて彼らを正しい道に立ち帰らせようとする。神のこの激しい愛を聖書では神の「妬み」あるいは「熱情」と表現する（エゼ16：42，39：25）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-107 class="m-1 text-dark dic-title">熱心党（ねっしんとう）</b-link>
              <b-collapse id="dictionary-collapse-107">
                <b-card>ユダヤ人の宗教的政治集団。ギリシア語ゼーロータイ。教理的には<span class="dic-reference">ファリサイ派</span>と一致していたが，<span class="dic-reference">メシア</span>の支配の実現を目指し，ローマ帝国の支配に対して武力を行使してもよいとしていた。ユダヤ戦争（後66-70年）の原因を作った主な勢力。イエスの12<span class="dic-reference">使徒</span>のうちにも，シモンという熱心党員がいた（ルカ6：15，使1：13）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-108 class="m-1 text-dark dic-title">逃れの町（のがれのまち）</b-link>
              <b-collapse id="dictionary-collapse-108">
                <b-card>過失により，人を死に至らしめた場合，その者が正当な裁判を受けるまで，そこにとどまり，私的復讐（血の復讐）を避けることができるように配慮された町（民35：9-28）。ヨルダン川の東と西に3つずつ設けられた（申19章）。ラモト・ギルアド，ヘブロン，シェケムなどである（ヨシュ20：2-9）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-109 class="m-1 text-dark dic-title">バアル</b-link>
              <b-collapse id="dictionary-collapse-109">
                <b-card><span class="dic-reference">アシェラ</span>や<span class="dic-reference">アシュトレト</span>と並んで，カナンの住民が礼拝した主神の名。本来は「主」「所有者」などの意味であったが，土地の所有者も指し，豊作をもたらす神の固有名詞となった。エリヤをはじめ旧約の<span class="dic-reference">預言者</span>は，バアル宗教と絶えず戦わねばならなかった（王上18～19章，ロマ11：4）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-110 class="m-1 text-dark dic-title">初穂（はつほ）</b-link>
              <b-collapse id="dictionary-collapse-110">
                <b-card>本来は最初に収穫される穀物の意味であるが，旧約で穀物や果実の初なり，家畜の初子などを神に献げることが定められていたことから，神への献げ物を指す用語となった（レビ23章，申26章など）。新約では，<span class="dic-reference">キリスト</span>が新しい人間の初穂として最初に復活され（1コリ15：20），また，最初にキリスト者になった者も「初穂」と呼ばれる（ロマ16：5，1コリ16：15など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-111 class="m-1 text-dark dic-title">バプテスマ</b-link>
              <b-collapse id="dictionary-collapse-111">
                <b-card>「洗礼〔バプテスマ〕」の項を見よ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-112 class="m-1 text-dark dic-title">ハルマゲドン</b-link>
              <b-collapse id="dictionary-collapse-112">
                <b-card>ヨハネの黙示録16：16によれば，<span class="dic-reference">悪魔</span>が神に敵対して，最後の決戦を挑むために全世界の王を集める場所。ヘブライ語の「メギドの丘」を音写したギリシア語。メギドが歴史上よく知られた古戦場であったため，終末の決戦場を象徴する名として選ばれたものであろう。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-113 class="m-1 text-dark dic-title">ハレルヤ</b-link>
              <b-collapse id="dictionary-collapse-113">
                <b-card>ヘブライ語で「ヤ（ヤハウェ＝主）を賛美せよ」の意味。旧約の詩編にはその冒頭か終結部，あるいはその両方でこの語を用いる作品がある（詩104，105，111，146編など）。特に第113編から第118編は「ハレル詩編」と呼ばれ，過越祭のときに歌われたという（マタ26：30）。新約ではヨハネの黙示録19：6の賛美の歌の中で使われている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-114 class="m-1 text-dark dic-title">反キリスト（はんキリスト）</b-link>
              <b-collapse id="dictionary-collapse-114">
                <b-card><span class="dic-reference">キリスト</span>と教会に敵対する者。<span class="dic-reference">終わりの時</span>に現れて人間を惑わす者（1ヨハ2：18，22，4：3，2ヨハ7）。2テサ2：1-12の「不法の者」や，マルコによる福音書13：22の「偽<span class="dic-reference">メシア</span>」なども同じ意味であろう。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-115 class="m-1 text-dark dic-title">パン種（パンだね）</b-link>
              <b-collapse id="dictionary-collapse-115">
                <b-card>発酵したパン生地の一部を取って，次のパンのために保存したものを言う。新約では，パンを膨らませる力を，神の国を成長させる力にたとえる場合（マタ13：33，ルカ13：21）と，反対に，ものを腐敗させる要素という意味で，<span class="dic-reference">ファリサイ派</span>やヘロデに当てはめて言う場合（マタ16：5-12）など，いずれも象徴的に用いられている。また，旧約でイスラエルがエジプトを脱出したときにパン種を入れないパンを食べた故事によって，<span class="dic-reference">除酵祭</span>が守られるようになったが，パウロはこのことをキリストの十字架の犠牲と結び付ける（1コリ5：6-8）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-116 class="m-1 text-dark dic-title">パンを裂く（パンをさく）</b-link>
              <b-collapse id="dictionary-collapse-116">
                <b-card>一つのパンを手でちぎって多くの人に分け，一緒に食べること。食卓を共にすることは<span class="dic-reference">兄弟</span>姉妹の交わりを意味した。イエスが多くの人にパンをお分けになった<span class="dic-reference">奇跡</span>（マタ14：19，ルカ9：16）や，最後の食事のとき（マコ14：22）などにこの表現が用いられている。また原始教会の信者たちの交わりも，パンを分け合う共同の食事を中心としていた（使2：42，46，20：7，11）。コリントの信徒への手紙1の10：16，11：23，24では，主の晩餐の典礼の用語となっていたと思われる。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-117 class="m-1 text-dark dic-title">秘義（ひぎ）</b-link>
              <b-collapse id="dictionary-collapse-117">
                <b-card>ギリシア語でミュステーリオン。ミステリーにつながる言葉で，秘密を意味する。エレウシスなどの古代の密儀宗教では，秘義は，密儀に参入する信者に与えられ秘匿される特権的な奥義を意味したが，新約聖書では，世々隠されていたが，今や神がイエス・キリストにおいて啓示した神の国（マコ4：11），福音（ロマ16：25），神の知恵（1コリ2：7）を意味する。用例（28回）のうち多くが，秘義を知り理解した者による宣教や解き明かしと結びついているのが密儀宗教と異なる特徴である（1コリ2：1，15：51，エフェ3：9，6：19，コロ2：2など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-118 class="m-1 text-dark dic-title">人の子（ひとのこ）</b-link>
              <b-collapse id="dictionary-collapse-118">
                <b-card>旧約では，ダニエル書（7：13，10：16）以外ではほとんどが「人間」の意味で用いられているが（創11：5，民23：19，詩8：5），新約では多くの場合<span class="dic-reference">メシア</span>（<span class="dic-reference">キリスト</span>）を指す術語である。しかも，唯一の例外（使7：56）を除いて，すべてイエスの言葉の中に用いられ，イエス自身の呼び名とされた。これはイエスの受難（マコ8：31），罪を赦す権威（マコ2：10），受けるべき栄光（マコ8：38）を表す。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-119 class="m-1 text-dark dic-title">ファラオ</b-link>
              <b-collapse id="dictionary-collapse-119">
                <b-card>古代エジプトの王の尊称。ファラオはギリシア語名で，ヘブライ語ではパロ。旧約では創世記（12：15-20）から列王記に至るまで（王下23：29）多くのファラオが登場している。原意は「大きな家」。新約には2人のファラオに関する言及がある。使徒言行録7：10-13（創40～47章）と使徒言行録7：21，ローマの信徒への手紙9：17，ヘブライ人への手紙11：24（出1：8～14：31）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-120 class="m-1 text-dark dic-title">ファリサイ派（ファリサイは）</b-link>
              <b-collapse id="dictionary-collapse-120">
                <b-card>起源はマカバイ時代の敬虔派（ハシディム）にあるとされ，イエスの時代には<span class="dic-reference">サドカイ派</span>と共に民衆に大きな影響力を持ち，イエスに敵対した。<span class="dic-reference">律法学者</span>の多くはファリサイ派に属していたと思われる（マタ23：2など）。<span class="dic-reference">律法</span>を守ること，特に<span class="dic-reference">安息日</span>や<span class="dic-reference">断食</span>，施しを行うことや宗教的な清めを強調し，口伝の<span class="dic-reference">律法</span>を重視するとともに，復活，<span class="dic-reference">天使</span>，霊を認めていた（使23：8）。語源のヘブライ語「ペルシム」は「分離される者」の意である。また，ルカによる福音書ではイエスを食事に招いたファリサイ派の人もいた（ルカ7：36）。また，パウロは，自らをファリサイ派と名乗っている（使23：6，フィリ3：5）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-121 class="m-1 text-dark dic-title">ベリアル</b-link>
              <b-collapse id="dictionary-collapse-121">
                <b-card><span class="dic-reference">キリスト</span>に敵対する<span class="dic-reference">悪魔</span>の名。旧約では，対応するヘブライ語ベリヤアルは「無価値なこと」「よこしまなこと」を意味する普通名詞であった（申13：14，ヨブ34：18では「よこしまな者」「ならず者」）が，新約時代には，固有名詞として用いられていた（2コリ6：15）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-122 class="m-1 text-dark dic-title">ベルゼブル</b-link>
              <b-collapse id="dictionary-collapse-122">
                <b-card><span class="dic-reference">悪霊</span>の支配者。<span class="dic-reference">神の霊</span>と対比される（マタ10：25，12：24，27）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-123 class="m-1 text-dark dic-title">弁護者（べんごしゃ）</b-link>
              <b-collapse id="dictionary-collapse-123">
                <b-card>ヨハネによる福音書および手紙の中で，<span class="dic-reference">聖霊</span>あるいは<span class="dic-reference">キリスト</span>を指す表現（ヨハ14：16，26，1ヨハ2：1）。神の前で人間を弁護し，執り成しをする働きに由来する。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-124 class="m-1 text-dark dic-title">捕囚（ほしゅう）</b-link>
              <b-collapse id="dictionary-collapse-124">
                <b-card>古代オリエント世界に多く見られた占領政策の一つで，戦勝国は敗戦国の指導者，軍人，ならびに有力，有益な住民を自国内に強制移住させて，謀反の再発を予防するとともに，自国の発展を図った。北イスラエル王国では，アッシリア王ティグラト・ピレセル三世（前744-727年在位）の治世下における捕囚を皮切りに数次行われた（王下15：29，17：5，6）。しかし一般に「捕囚」と言うときは，バビロニア王ネブカドネツァル（前605-562年在位）によって前598年から3回にわたって行われた南ユダ王国のそれを指す（王下24：14-16，25：11，12，21）。この捕囚で約4600人の成人男子がバビロニア国内に移住させられ（エレ52：30），前538年ペルシアの王キュロスの帰還命令発布までの約60年間，外国での生活を強いられた（詩137編）。バビロンに移住した人たちが，いわゆる「残りの者」（ゼファ3：12，13など）となってイスラエルの復興の中核となった。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-125 class="m-1 text-dark dic-title">幕屋（まくや）</b-link>
              <b-collapse id="dictionary-collapse-125">
                <b-card>荒れ野の旅の「移動聖所」。天幕で仕切られた場所に<span class="dic-reference">至聖所</span>を設け，そこに<span class="dic-reference">契約の箱</span>を安置した（出40章）。民数記2章では，幕屋は宿営の中心に位置しているが，他の伝承によると（出33：7），宿営の外に張られた天幕を「会見の幕屋」と名付け，主に尋ねるときはいつも，モーセは会見の幕屋に出かけて行ったとしている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-126 class="m-1 text-dark dic-title">マナ</b-link>
              <b-collapse id="dictionary-collapse-126">
                <b-card>イスラエルがエジプトを脱出して，荒れ野を旅したときに，天から与えられた食物（出16：14-35，民11：7-9）。これを見た人々が「これは何だろう（マン・フ）」と言ったので，この名で呼ばれるようになった。旧約ギリシア語では「マン」であるが，新約ギリシア語では「マンナ」と呼んでいる（本訳では新約でも「マナ」と表記した）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-127 class="m-1 text-dark dic-title">幻（まぼろし）</b-link>
              <b-collapse id="dictionary-collapse-127">
                <b-card>地上の<span class="dic-reference">預言者</span>などが超越の神からメッセージを託される特殊な現象の中で与えられる神の言葉または啓示。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-128 class="m-1 text-dark dic-title">メシア</b-link>
              <b-collapse id="dictionary-collapse-128">
                <b-card>「油（を）注がれた者」の意で旧約聖書では38回用いられている。イスラエルでは「王」（サム下2：4）「<span class="dic-reference">祭司</span>」（出29：7）が，就任式のとき油を注がれた。後に，正しい治世をもって国を治める理想的王を示すようになり（イザ11：1-10），さらに神の決定的な救いをもたらす「救い主」を指すようになった。新約時代の人々は政治的解放をもたらすメシアを待望していたが，イエスはそれを拒否し，十字架の死によって人々を罪から救うメシアであることを主張された。新約聖書は，イエスがこの意味のメシアであることを主張し，イエスに「<span class="dic-reference">キリスト</span>」（メシアのギリシア語訳）という名称を付した（マタ1：1，16：16）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-129 class="m-1 text-dark dic-title">メルキゼデク</b-link>
              <b-collapse id="dictionary-collapse-129">
                <b-card>意味は「義の王」。詩編110：4に出，創世記14：18によれば「サレムの王」。ヘブライ人への手紙5～7章においては<span class="dic-reference">キリスト</span>を説明するものとなっている。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-130 class="m-1 text-dark dic-title">焼き尽くすいけにえ（やきつくすいけにえ）</b-link>
              <b-collapse id="dictionary-collapse-130">
                <b-card>「献げ物」の項を見よ。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-131 class="m-1 text-dark dic-title">ユダヤ人（ユダヤじん）</b-link>
              <b-collapse id="dictionary-collapse-131">
                <b-card>旧約聖書においては，バビロン<span class="dic-reference">捕囚</span>（前587年）前はユダ部族に属する人々を意味し，<span class="dic-reference">捕囚</span>後（前538年）は，<span class="dic-reference">サマリア人</span>を除くイスラエル民族に属する人々を指す。イエスの時代には，ユダヤ人は，民族的アイデンティティを保持しつつ地中海全域に離散して移住していた。そして，父祖伝来の<span class="dic-reference">律法</span>と宗教習慣を遵守するユダヤ人と，その<span class="dic-reference">律法</span>の成就者のイエスを<span class="dic-reference">メシア</span>と信じる「ユダヤ人キリスト者」が生まれた。新約聖書中，ユダヤ人キリスト者（あるいはイエス）と，ユダヤ教徒の間の対立・抗争の文脈中の「ユダヤ人」の語には人種・民族間の差別問題はない。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-132 class="m-1 text-dark dic-title">世（よ）</b-link>
              <b-collapse id="dictionary-collapse-132">
                <b-card>旧約聖書では，宇宙や世界を指すのに「天と地」と言っている。神は，「天と地と海と，そこにあるすべてのものを造り」（出20：11），地上にあるすべてのものを人間の支配に委ねた（創1：28）。しかし，人間の罪の結果，地上には悪と不幸が生じ（創3：16-19），世界（世）はその「支配者」（ヨハ12：31）と呼ばれる<span class="dic-reference">サタン</span>の下に置かれ，<span class="dic-reference">キリスト</span>に反するものとなった（1ヨハ4：3，5）。キリスト者は，悪によって支配される世を愛してはならない（1ヨハ2：15）。しかし神は世を創造し，「その独り子をお与えになったほどに，世を愛され」（ヨハ3：16），彼によってサタンの勢力を砕き（ヘブ2：14，ヨハ14：30，16：33），万物を新しくされる（黙21：5）。「世の光」（マタ5：14）として立てられたキリスト者は，<span class="dic-reference">キリスト</span>によって始められている「来るべき世の力」をすでに味わっている（ヘブ6：5）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-133 class="m-1 text-dark dic-title">預言（よげん）</b-link>
              <b-collapse id="dictionary-collapse-133">
                <b-card>神の召命を受けた人（<span class="dic-reference">預言者</span>）が神より託された言葉。その内容は，神との<span class="dic-reference">契約</span>に違反したときの「罪の告発」や「裁きの宣告」が主であるが，裁きの後には「救いの約束」が託された。新約では，主として旧約の「救いの約束」の預言がイエス・<span class="dic-reference">キリスト</span>の出来事において成就した，と解された（マタ1：22，2：5，ヨハ12：38，使3：25，1コリ15：54）。初代教会の<span class="dic-reference">預言者</span>の場合には，<span class="dic-reference">聖霊</span>に感じて語る言葉の意味である（1コリ14：1-5）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-134 class="m-1 text-dark dic-title">預言者（よげんしゃ）</b-link>
              <b-collapse id="dictionary-collapse-134">
                <b-card>神の召命を受け，神の言葉を伝える使命を担った人。王国分裂後の預言者たちの言葉は，後に文書にまとめられ，いわゆる預言書として編纂され，ヘブライ語の聖書には，その第2部に集録された。古代のギリシア語訳，ラテン語訳，および大多数の現代語訳には，旧約聖書の最後の部分に収録されている。新約では，旧約の預言者個人を指す場合（マタ3：3，4：14）と，「<span class="dic-reference">律法</span>と預言者」というように，旧約の第2部を意味する場合がある。また，初代教会には<span class="dic-reference">使徒</span>の次に教師，<span class="dic-reference">奇跡</span>を行う者などと並んで預言者がいた（1コリ12：28）。これは神の霊によって預言をする能力を与えられた人であった（1コリ14：1）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-135 class="m-1 text-dark dic-title">ヨベルの年（ヨベルのとし）</b-link>
              <b-collapse id="dictionary-collapse-135">
                <b-card>イスラエルでは，農地を疲弊させないために休耕年を設けていた（安息年）。この安息年を7回繰り返した翌年，つまり50年目をヨベルの年と呼んだ（レビ25：8以下）。ヨベルの年には，人手に渡っていた先祖伝来の土地は元の所有者に無償で返還され，奴隷となった者は解放された。この喜ばしい年の始まりを，「雄羊の角（ヨベル）」を吹いて告知したので，この呼び名となった。自らの責任によらない社会的・経済的格差を解消しようとする極めて高い理想を示した制度であるが，古代イスラエルの社会で実際に守られていたかどうかは定かではない。イエスはナザレの会堂でイザヤ書61：1，2を引用しながら，その宣教によって，罪からの解放を告げる新しいヨベルの年の始まりを宣言している（ルカ4：16-19）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-136 class="m-1 text-dark dic-title">陰府（よみ）</b-link>
              <b-collapse id="dictionary-collapse-136">
                <b-card>ヘブライ語「シェオル」，ギリシア語「ハデス」。死者が集められる場所で，地下にあると思われていた。この語は旧約では65回，新約では10回使われている。イエスも死後は陰府に降り（1ペト3：19，20），そこから復活することによって死の力を打ち砕かれた（1コリ15：26）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-137 class="m-1 text-dark dic-title">律法（りっぽう）</b-link>
              <b-collapse id="dictionary-collapse-137">
                <b-card>神の意志による教えと戒めのこと。神は，イスラエルの民と<span class="dic-reference">契約</span>を結び，人間の守るべき道として，<span class="dic-reference">十戒</span>その他の戒めを与えた（出20：22～23：33など）。それには道徳律のほかに，祭儀規定，社会法規，種々の勧告なども含まれている。民はそれらを守ることによって，神の選びの愛と<span class="dic-reference">契約</span>に応えなければならないとされた。しかし，広義には，旧約の創世記，出エジプト記，レビ記，民数記，申命記の5書を指す。「モーセ五書」とも呼ばれる。新約では，「律法と<span class="dic-reference">預言者</span>」という用語が旧約全体を指す場合もある（マタ5：17，ルカ16：16，17）。イエスは，律法を形式的に守る律法主義には反対したが，律法を廃止するためではなく，それを完成するために来たと宣言し（マタ5：17），律法の中で最も重要な戒めは愛であると説かれた（マタ22：36-40）。パウロは，人が律法を実行することによっては神の前で<span class="dic-reference">義</span>とされず，イエス・キリストを信じることによって，神の<span class="dic-reference">義</span>が人々に与えられることを教えている（ロマ3：19-31，7章，ガラ3章など）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-138 class="m-1 text-dark dic-title">律法学者（りっぽうがくしゃ）</b-link>
              <b-collapse id="dictionary-collapse-138">
                <b-card><span class="dic-reference">律法</span>を専門に研究し，解釈して民に教えた教師。優れた学者は多くの弟子を持ち，<span class="dic-reference">最高法院</span>の<span class="dic-reference">議員</span>など，社会的に尊敬される地位にあった。律法学者の多くは<span class="dic-reference">ファリサイ派</span>に属していたと思われる（マコ2：16，使5：34，23：9）。マタイによる福音書では，<span class="dic-reference">サドカイ派</span>と共に律法学者，<span class="dic-reference">ファリサイ派</span>がイエスから非難されている（マタ22：29-32，23：1-36）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-139 class="m-1 text-dark dic-title">レカブ人（レカブじん）</b-link>
              <b-collapse id="dictionary-collapse-139">
                <b-card>ケニ人レカブの子孫で，イスラエルの民のカナン定着後も，荒れ野の生活を守り通した遊牧民族。レカブ人ヨナダブは，クーデターによって北イスラエルの王になったばかりのイエフに協力して<span class="dic-reference">バアル</span>礼拝の根絶に一役買った（王下10：15-27）。エレミヤ書35章では，神はレカブ人が父祖の伝承を固守して酒も飲まず，定住する家も造らず，富も持たずに神に対する忠誠を守っていることを称賛している。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-140 class="m-1 text-dark dic-title">レギオン</b-link>
              <b-collapse id="dictionary-collapse-140">
                <b-card>ローマの軍隊組織の軍団単位で，歩兵を主体に騎兵を含む兵士の数は新約時代には5000人余りであったと見られる。「多数」を意味する語としても用いられた。ゲラサの<span class="dic-reference">悪霊</span>（汚れた霊）に取りつかれた人が「レギオン」と名乗った（マコ5：9，ルカ8：30）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-141 class="m-1 text-dark dic-title">レビ人（レビびと）</b-link>
              <b-collapse id="dictionary-collapse-141">
                <b-card>十二族長の一人であるレビの子孫で，世襲により聖職を担当した。初めはレビ人と<span class="dic-reference">祭司</span>は同意語であったが，<span class="dic-reference">祭司</span>がレビ族の一人アロンの子孫に限定されるようになってからは，下位の聖職を果たす者を指すようになった（民3章）。それはヨシヤ王の改革で地方聖所が廃止され，エルサレムの<span class="dic-reference">神殿</span>に祭儀が集中されたことによるものと考えられている。レビ人は神殿での奉仕（代上24～26章）のほかに民の教育にも当たった（代下17：8，9）。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-142 class="m-1 text-dark dic-title">レビヤタン</b-link>
              <b-collapse id="dictionary-collapse-142">
                <b-card>ヨブ記（3：8，40：25以下），イザヤ書（27：1）などに登場する，古代オリエント世界の神話的な怪獣。蛇か，鰐（わに）のようなものと考えられ，宇宙創世以前の混沌のシンボルであった。しかしイスラエルでは神に退治される怪獣（詩74：14），もしくは，神の前に戯れる，害のない生き物となっている（詩104：26）。なお，ヨブ記40：15に出てくる「ベヘモット」も同じような怪獣である。</b-card>
              </b-collapse>

              <b-link v-b-toggle.dictionary-collapse-143 class="m-1 text-dark dic-title">六百六十六（ろっぴゃくろくじゅうろく）</b-link>
              <b-collapse id="dictionary-collapse-143">
                <b-card>ヨハネの黙示録13：18で，ある人物の名を暗示する数字。ヘブライ語やギリシア語，ラテン語には特別な数字はなく，アルファベットの文字がそれぞれ数を表す。数を用いた暗号は，逆に文字に戻して解読することができる。666について最も有力な説は，ヘブライ語でネロ皇帝と読む解釈である。</b-card>
              </b-collapse>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1 px-3" style="cursor: pointer;" v-b-toggle.reference-accordion-6>
            旧約聖書 章・節対応表
          </b-card-header>
          <b-collapse id="reference-accordion-6">
            <b-card-body>
              <p>この表は旧約における新共同訳／聖書協会共同訳の底本の章・節と，日本聖書協会口語聖書の章・節とが相違している箇所ごとに，左欄では新共同訳／聖書協会共同訳の範囲を，右欄にはそれに相応する口語聖書の範囲を示したものである。</p>

              <table class="table table-bordered mt-5">
                <thead>
                  <tr class="comparison-bible table-secondary">
                    <th scope="col" colspan="2">新共同訳<br>聖書協会共同訳</th>
                    <th scope="col" colspan="2">口語訳聖書</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">創世記</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">32</th>
                    <td>1</td>
                    <th>31</th>
                    <td>55</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">32</th>
                    <td>2～33</td>
                    <th>32</th>
                    <td>1～32</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">出エジプト記</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">7</th>
                    <td>26～29</td>
                    <th>8</th>
                    <td>1～4</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">8</th>
                    <td>1～28</td>
                    <th>8</th>
                    <td>5～32</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">21</th>
                    <td>37</td>
                    <th>22</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">22</th>
                    <td>1～30</td>
                    <th>22</th>
                    <td>2～31</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">レビ記</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">5</th>
                    <td>20～26</td>
                    <th>6</th>
                    <td>1～7</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">6</th>
                    <td>1～23</td>
                    <th>6</th>
                    <td>8～30</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">民数記</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">17</th>
                    <td>1～15</td>
                    <th>16</th>
                    <td>36～50</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">17</th>
                    <td>16～28</td>
                    <th>17</th>
                    <td>1～13</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">25</th>
                    <td>19</td>
                    <th>26</th>
                    <td>1(a)</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">26</th>
                    <td>1～65</td>
                    <th>26</th>
                    <td>1(b)～65</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">30</th>
                    <td>1</td>
                    <th>29</th>
                    <td>40</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">30</th>
                    <td>2～17</td>
                    <th>30</th>
                    <td>1～16</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">申命記</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">13</th>
                    <td>1</td>
                    <th>12</th>
                    <td>32</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">13</th>
                    <td>2～19</td>
                    <th>13</th>
                    <td>1～18</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">23</th>
                    <td>1</td>
                    <th>22</th>
                    <td>30</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">23</th>
                    <td>2～26</td>
                    <th>23</th>
                    <td>1～25</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">28</th>
                    <td>69</td>
                    <th>29</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">29</th>
                    <td>1～28</td>
                    <th>29</th>
                    <td>2～29</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">サムエル記上</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">4</th>
                    <td>1(a)</td>
                    <th>3</th>
                    <td>21(b)</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">4</th>
                    <td>1(b)</td>
                    <th>4</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">21</th>
                    <td>1</td>
                    <th>20</th>
                    <td>42(b)</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">21</th>
                    <td>2～16</td>
                    <th>21</th>
                    <td>1～15</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">24</th>
                    <td>1</td>
                    <th>23</th>
                    <td>29</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">24</th>
                    <td>2～23</td>
                    <th>24</th>
                    <td>1～22</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">サムエル記下</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">19</th>
                    <td>1</td>
                    <th>18</th>
                    <td>33</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">19</th>
                    <td>2～44</td>
                    <th>19</th>
                    <td>1～43</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">列王記上</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">5</th>
                    <td>1～14</td>
                    <th>4</th>
                    <td>21～34</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">5</th>
                    <td>15～32</td>
                    <th>5</th>
                    <td>1～18</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">22</th>
                    <td>43</td>
                    <th>22</th>
                    <td>43(a)</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">22</th>
                    <td>44～54</td>
                    <th>22</th>
                    <td>43(b)～53</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">列王記下</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">12</th>
                    <td>1</td>
                    <th>11</th>
                    <td>21</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">12</th>
                    <td>2～22</td>
                    <th>12</th>
                    <td>1～21</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">歴代誌上</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">5</th>
                    <td>27～41</td>
                    <th>6</th>
                    <td>1～15</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">6</th>
                    <td>1～66</td>
                    <th>6</th>
                    <td>16～81</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">12</th>
                    <td>5～41</td>
                    <th>12</th>
                    <td>4(b)～40</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">歴代誌下</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">1</th>
                    <td>18</td>
                    <th>2</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">2</th>
                    <td>1～17</td>
                    <th>2</th>
                    <td>2～18</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">13</th>
                    <td>23</td>
                    <th>14</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">14</th>
                    <td>1～14</td>
                    <th>14</th>
                    <td>2～15</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">ネヘミヤ記</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">3</th>
                    <td>33～38</td>
                    <th>4</th>
                    <td>1～6</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">4</th>
                    <td>1～17</td>
                    <th>4</th>
                    <td>7～23</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">7</th>
                    <td>68～72</td>
                    <th>7</th>
                    <td>69～73</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">10</th>
                    <td>1</td>
                    <th>9</th>
                    <td>38</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">10</th>
                    <td>2～40</td>
                    <th>10</th>
                    <td>1～39</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">ヨブ記</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">40</th>
                    <td>25～32</td>
                    <th>41</th>
                    <td>1～8</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">41</th>
                    <td>1～26</td>
                    <th>41</th>
                    <td>9～34</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">コヘレトの言葉</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">4</th>
                    <td>17</td>
                    <th>5</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">5</th>
                    <td>1～19</td>
                    <th>5</th>
                    <td>2～20</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">雅歌</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">7</th>
                    <td>1</td>
                    <th>6</th>
                    <td>13</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">7</th>
                    <td>2～14</td>
                    <th>7</th>
                    <td>1～13</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">イザヤ書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">8</th>
                    <td>23</td>
                    <th>9</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">9</th>
                    <td>1～20</td>
                    <th>9</th>
                    <td>2～21</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">63</th>
                    <td>19</td>
                    <th>64</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">64</th>
                    <td>1～11</td>
                    <th>64</th>
                    <td>2～12</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">エレミヤ書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">8</th>
                    <td>23</td>
                    <th>9</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">9</th>
                    <td>1～25</td>
                    <th>9</th>
                    <td>2～26</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">エゼキエル書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">21</th>
                    <td>1～5</td>
                    <th>20</th>
                    <td>45～49</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">21</th>
                    <td>6～37</td>
                    <th>21</th>
                    <td>1～32</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">ダニエル書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">3</th>
                    <td>31～33</td>
                    <th>4</th>
                    <td>1～3</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">4</th>
                    <td>1～34</td>
                    <th>4</th>
                    <td>4～37</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">6</th>
                    <td>1</td>
                    <th>5</th>
                    <td>31</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">6</th>
                    <td>2～29</td>
                    <th>6</th>
                    <td>1～28</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">ホセア書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">2</th>
                    <td>1～2</td>
                    <th>1</th>
                    <td>10～11</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">2</th>
                    <td>3～25</td>
                    <th>2</th>
                    <td>1～23</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">12</th>
                    <td>1</td>
                    <th>11</th>
                    <td>12</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">12</th>
                    <td>2～15</td>
                    <th>12</th>
                    <td>1～14</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">14</th>
                    <td>1</td>
                    <th>13</th>
                    <td>16</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">14</th>
                    <td>2～10</td>
                    <th>14</th>
                    <td>1～9</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">ヨエル書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">3</th>
                    <td>1～5</td>
                    <th>2</th>
                    <td>28～32</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">4</th>
                    <td>1～21</td>
                    <th>3</th>
                    <td>1～21</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">ヨナ書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">2</th>
                    <td>1</td>
                    <th>1</th>
                    <td>17</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">2</th>
                    <td>2～11</td>
                    <th>2</th>
                    <td>1～10</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">ミカ書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">4</th>
                    <td>14</td>
                    <th>5</th>
                    <td>1</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">5</th>
                    <td>1～14</td>
                    <th>5</th>
                    <td>2～15</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">ナホム書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">2</th>
                    <td>1</td>
                    <th>1</th>
                    <td>15</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">2</th>
                    <td>2～14</td>
                    <th>2</th>
                    <td>1～13</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">ゼカリヤ書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">2</th>
                    <td>1～4</td>
                    <th>1</th>
                    <td>18～21</td>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">2</th>
                    <td>5～17</td>
                    <th>2</th>
                    <td>1～13</td>
                  </tr>
                  <tr class="comparison-book table-secondary">
                    <th scope="row" colspan="4">マラキ書</th>
                  </tr>
                  <tr class="comparison-data">
                    <th scope="row">3</th>
                    <td>19～24</td>
                    <th>4</th>
                    <td>1～6</td>
                  </tr>
                </tbody>
              </table>

              <p>上記各書のほか「詩編」においても，次の（1）では1節ずつ，（2）では2節ずつ，節数字がずれている。これは新共同訳聖書／聖書協会共同訳聖書の底本が「表題」（小さい活字で印刷）を節区分の中に入れているのに対し，口語聖書では「表題」の終わったところから，第1節が始まっているためである。</p>
              <p>（1）3～9, 12～13, 18～22, 30～31, 34, 36, 38～42, 44～49, 53, 55～59, 61～65, 67～70, 75～77, 80～81, 83～85, 88～89, 92, 102, 108, 140, 142</p>
              <p>（2）51～52, 54, 60</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1 px-3" style="cursor: pointer;" v-b-toggle.reference-accordion-7>
            新約聖書における旧約聖書からの引用箇所一覧表
          </b-card-header>
          <b-collapse id="reference-accordion-7">
            <b-card-body>
              <p>この表は，新約聖書中に引用された旧約聖書の箇所を，新約聖書の各書ごとに示したものである。 （LXX は七十人訳ギリシア語聖書を表す）</p>

              <table class="table table-bordered mt-5">
                <thead>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">マタイによる福音書</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="quote-data">
                    <th scope="row">1:23a</th>
                    <td>イザ</td>
                    <td>7:14LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:23b</th>
                    <td>イザ</td>
                    <td>8:8,10LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:6</th>
                    <td>ミカ</td>
                    <td>5:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:15</th>
                    <td>ホセ</td>
                    <td>11:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:18</th>
                    <td>エレ</td>
                    <td>31:15</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:3</th>
                    <td>イザ</td>
                    <td>40:3LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:4</th>
                    <td>申</td>
                    <td>8:3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:6</th>
                    <td>詩</td>
                    <td>91:11―12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:7</th>
                    <td>申</td>
                    <td>6:16</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:10</th>
                    <td>申</td>
                    <td>6:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:15―16</th>
                    <td>イザ</td>
                    <td>8:23～9:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:21</th>
                    <td>出</td>
                    <td>20:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:17</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:27</th>
                    <td>出</td>
                    <td>20:14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:31</th>
                    <td>申</td>
                    <td>24:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:33</th>
                    <td>レビ</td>
                    <td>19:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>民</td>
                    <td>30:3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:38</th>
                    <td>出</td>
                    <td>21:24</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>レビ</td>
                    <td>24:20</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>19:21</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:43</th>
                    <td>レビ</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">8:17</th>
                    <td>イザ</td>
                    <td>53:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:13</th>
                    <td>ホセ</td>
                    <td>6:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:35―36</th>
                    <td>ミカ</td>
                    <td>7:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:10</th>
                    <td>マラ</td>
                    <td>3:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:7</th>
                    <td>ホセ</td>
                    <td>6:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:18―20</th>
                    <td>イザ</td>
                    <td>42:1―3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:21</th>
                    <td>イザ</td>
                    <td>42:4LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:40</th>
                    <td>ヨナ</td>
                    <td>2:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:14―15</th>
                    <td>イザ</td>
                    <td>6:9―10LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:35</th>
                    <td>詩</td>
                    <td>78:2</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:4a</th>
                    <td>出</td>
                    <td>20:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:16</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:4b</th>
                    <td>出</td>
                    <td>21:17</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:8―9</th>
                    <td>イザ</td>
                    <td>29:13LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">18:16</th>
                    <td>申</td>
                    <td>19:15</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:4</th>
                    <td>創</td>
                    <td>1:27</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td></td>
                    <td>5:2</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:5</th>
                    <td>創</td>
                    <td>2:24</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:7</th>
                    <td>申</td>
                    <td>24:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:18―19</th>
                    <td>出</td>
                    <td>20:12―16</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:16―20</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:19</th>
                    <td>レビ</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">21:5</th>
                    <td>イザ</td>
                    <td>62:11</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>ゼカ</td>
                    <td>9:9</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">21:9</th>
                    <td>詩</td>
                    <td>118:25―26</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">21:13</th>
                    <td>イザ</td>
                    <td>56:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">21:16</th>
                    <td>詩</td>
                    <td>8:3LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">21:42</th>
                    <td>詩</td>
                    <td>118:22―23</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">22:24</th>
                    <td>申</td>
                    <td>25:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">22:32</th>
                    <td>出</td>
                    <td>3:6,15</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">22:37</th>
                    <td>申</td>
                    <td>6:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">22:39</th>
                    <td>レビ</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">22:44</th>
                    <td>詩</td>
                    <td>110:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">23:39</th>
                    <td>詩</td>
                    <td>118:26</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">24:30</th>
                    <td>ダニ</td>
                    <td>7:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">26:31</th>
                    <td>ゼカ</td>
                    <td>13:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">26:64a</th>
                    <td>詩</td>
                    <td>110:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">26:64b</th>
                    <td>ダニ</td>
                    <td>7:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">27:9―10</th>
                    <td>ゼカ</td>
                    <td>11:12―13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">27:46</th>
                    <td>詩</td>
                    <td>22:2</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">マルコによる福音書</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:2</th>
                    <td>マラ</td>
                    <td>3:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:3</th>
                    <td>イザ</td>
                    <td>40:3LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:12</th>
                    <td>イザ</td>
                    <td>6:9―10LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:6―7</th>
                    <td>イザ</td>
                    <td>29:13LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:10a</th>
                    <td>出</td>
                    <td>20:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:16</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:10b</th>
                    <td>出</td>
                    <td>21:17</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:4</th>
                    <td>申</td>
                    <td>24:1,3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:6</th>
                    <td>創</td>
                    <td>1:27</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td></td>
                    <td>5:2</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:7―8</th>
                    <td>創</td>
                    <td>2:24</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:19</th>
                    <td>出</td>
                    <td>20:12―16</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:16―20</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:9―10</th>
                    <td>詩</td>
                    <td>118:25―26</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:17</th>
                    <td>イザ</td>
                    <td>56:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:10―11</th>
                    <td>詩</td>
                    <td>118:22―23</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:19</th>
                    <td>申</td>
                    <td>25:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:26</th>
                    <td>出</td>
                    <td>3:6,15</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:29―30</th>
                    <td>申</td>
                    <td>6:4―5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:31</th>
                    <td>レビ</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:32a</th>
                    <td>申</td>
                    <td>6:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:32b</th>
                    <td>申</td>
                    <td>4:35</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>イザ</td>
                    <td>45:21</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:33a</th>
                    <td>申</td>
                    <td>6:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:33b</th>
                    <td>レビ</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:36</th>
                    <td>詩</td>
                    <td>110:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:26</th>
                    <td>ダニ</td>
                    <td>7:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">14:27</th>
                    <td>ゼカ</td>
                    <td>13:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">14:62a</th>
                    <td>詩</td>
                    <td>110:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">14:62b</th>
                    <td>ダニ</td>
                    <td>7:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:34</th>
                    <td>詩</td>
                    <td>22:2</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">ルカによる福音書</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:23</th>
                    <td>出</td>
                    <td>13:2,12,15</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:24</th>
                    <td>レビ</td>
                    <td>12:8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:4―6</th>
                    <td>イザ</td>
                    <td>40:3―5LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:4</th>
                    <td>申</td>
                    <td>8:3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:8</th>
                    <td>申</td>
                    <td>6:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:10―11</th>
                    <td>詩</td>
                    <td>91:11―12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:12</th>
                    <td>申</td>
                    <td>6:16</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:18―19</th>
                    <td>イザ</td>
                    <td>61:1―2LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:27</th>
                    <td>マラ</td>
                    <td>3:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">8:10</th>
                    <td>イザ</td>
                    <td>6:9LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:27a</th>
                    <td>申</td>
                    <td>6:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:27b</th>
                    <td>レビ</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:35</th>
                    <td>詩</td>
                    <td>118:26</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">18:20</th>
                    <td>出</td>
                    <td>20:12―16</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:16―20</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:38</th>
                    <td>詩</td>
                    <td>118:26</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:46</th>
                    <td>イザ</td>
                    <td>56:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">20:17</th>
                    <td>詩</td>
                    <td>118:22</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">20:28</th>
                    <td>申</td>
                    <td>25:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">20:37</th>
                    <td>出</td>
                    <td>3:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">20:42―43</th>
                    <td>詩</td>
                    <td>110:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">21:27</th>
                    <td>ダニ</td>
                    <td>7:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">22:37</th>
                    <td>イザ</td>
                    <td>53:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">22:69</th>
                    <td>詩</td>
                    <td>110:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">23:30</th>
                    <td>ホセ</td>
                    <td>10:8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">23:46</th>
                    <td>詩</td>
                    <td>31:6</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">ヨハネによる福音書</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:23</th>
                    <td>イザ</td>
                    <td>40:3LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:17</th>
                    <td>詩</td>
                    <td>69:10</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:31</th>
                    <td>詩</td>
                    <td>78:24</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:45</th>
                    <td>イザ</td>
                    <td>54:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:34</th>
                    <td>詩</td>
                    <td>82:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:13</th>
                    <td>詩</td>
                    <td>118:25―26</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:15</th>
                    <td>ゼカ</td>
                    <td>9:9</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:38</th>
                    <td>イザ</td>
                    <td>53:1LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:40</th>
                    <td>イザ</td>
                    <td>6:10LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:18</th>
                    <td>詩</td>
                    <td>41:10</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:25</th>
                    <td>詩</td>
                    <td>35:19</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td></td>
                    <td>69:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:24</th>
                    <td>詩</td>
                    <td>22:19</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:36</th>
                    <td>出</td>
                    <td>12:46</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>民</td>
                    <td>9:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">19:37</th>
                    <td>ゼカ</td>
                    <td>12:10</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">使徒言行録</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:20a</th>
                    <td>詩</td>
                    <td>69:26</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:20b</th>
                    <td>詩</td>
                    <td>109:8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:17―21</th>
                    <td>ヨエ</td>
                    <td>3:1―5LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:25―28</th>
                    <td>詩</td>
                    <td>16:8―11LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:30</th>
                    <td>詩</td>
                    <td>132:11</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:31</th>
                    <td>詩</td>
                    <td>16:10</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:34―35</th>
                    <td>詩</td>
                    <td>110:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:13</th>
                    <td>出</td>
                    <td>3:6,15</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:22</th>
                    <td>申</td>
                    <td>18:15―16</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:23a</th>
                    <td>申</td>
                    <td>18:19</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:23b</th>
                    <td>レビ</td>
                    <td>23:29</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:25</th>
                    <td>創</td>
                    <td>22:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td></td>
                    <td>26:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:11</th>
                    <td>詩</td>
                    <td>118:22</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:25―26</th>
                    <td>詩</td>
                    <td>2:1―2LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:3</th>
                    <td>創</td>
                    <td>12:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:5</th>
                    <td>創</td>
                    <td>17:8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td></td>
                    <td>48:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:6―7</th>
                    <td>創</td>
                    <td>15:13―14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:7</th>
                    <td>出</td>
                    <td>3:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:18</th>
                    <td>出</td>
                    <td>1:8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:27―28</th>
                    <td>出</td>
                    <td>2:14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:30</th>
                    <td>出</td>
                    <td>3:2</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:32</th>
                    <td>出</td>
                    <td>3:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:33</th>
                    <td>出</td>
                    <td>3:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:34</th>
                    <td>出</td>
                    <td>3:7,8,10</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:35</th>
                    <td>出</td>
                    <td>2:14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:37</th>
                    <td>申</td>
                    <td>18:15</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:40</th>
                    <td>出</td>
                    <td>32:1,23</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:42―43</th>
                    <td>アモ</td>
                    <td>5:25―27LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:49―50</th>
                    <td>イザ</td>
                    <td>66:1―2</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">8:32―33</th>
                    <td>イザ</td>
                    <td>53:7―8LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:22a</th>
                    <td>詩</td>
                    <td>89:21</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:22b</th>
                    <td>サム上</td>
                    <td>13:14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:33</th>
                    <td>詩</td>
                    <td>2:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:34</th>
                    <td>イザ</td>
                    <td>55:3LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:35</th>
                    <td>詩</td>
                    <td>16:10LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:41</th>
                    <td>ハバ</td>
                    <td>1:5LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:47</th>
                    <td>イザ</td>
                    <td>49:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:16―17</th>
                    <td>アモ</td>
                    <td>9:11―12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">23:5</th>
                    <td>出</td>
                    <td>22:27</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">28:26―27</th>
                    <td>イザ</td>
                    <td>6:9―10LXX</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">ローマの信徒への手紙</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:17</th>
                    <td>ハバ</td>
                    <td>2:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:24</th>
                    <td>イザ</td>
                    <td>52:5LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:4</th>
                    <td>詩</td>
                    <td>51:6LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:10―12</th>
                    <td>詩</td>
                    <td>14:1―3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td></td>
                    <td>（53:2―4）</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:13a</th>
                    <td>詩</td>
                    <td>5:10LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:13b</th>
                    <td>詩</td>
                    <td>140:4LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:14</th>
                    <td>詩</td>
                    <td>10:7LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:15―17</th>
                    <td>イザ</td>
                    <td>59:7―8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:18</th>
                    <td>詩</td>
                    <td>36:2</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:3</th>
                    <td>創</td>
                    <td>15:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:7―8</th>
                    <td>詩</td>
                    <td>32:1―2</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:9</th>
                    <td>創</td>
                    <td>15:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:17</th>
                    <td>創</td>
                    <td>17:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:18a</th>
                    <td>創</td>
                    <td>17:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:18b</th>
                    <td>創</td>
                    <td>15:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:22</th>
                    <td>創</td>
                    <td>15:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:7</th>
                    <td>出</td>
                    <td>20:17</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:21</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">8:36</th>
                    <td>詩</td>
                    <td>44:23</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:7</th>
                    <td>創</td>
                    <td>21:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:9</th>
                    <td>創</td>
                    <td>18:10,14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:12</th>
                    <td>創</td>
                    <td>25:23</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:13</th>
                    <td>マラ</td>
                    <td>1:2―3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:15</th>
                    <td>出</td>
                    <td>33:19</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:17</th>
                    <td>出</td>
                    <td>9:16LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:25</th>
                    <td>ホセ</td>
                    <td>2:25</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:26</th>
                    <td>ホセ</td>
                    <td>2:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:27―28</th>
                    <td>イザ</td>
                    <td>10:22―23LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:29</th>
                    <td>イザ</td>
                    <td>1:9LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:33</th>
                    <td>イザ</td>
                    <td>8:14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td></td>
                    <td>28:16LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:5</th>
                    <td>レビ</td>
                    <td>18:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:6</th>
                    <td>申</td>
                    <td>9:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:6―8</th>
                    <td>申</td>
                    <td>30:12―14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:11</th>
                    <td>イザ</td>
                    <td>28:16LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:13</th>
                    <td>ヨエ</td>
                    <td>3:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:15</th>
                    <td>イザ</td>
                    <td>52:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:16</th>
                    <td>イザ</td>
                    <td>53:1LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:18</th>
                    <td>詩</td>
                    <td>19:5LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:19</th>
                    <td>申</td>
                    <td>32:21</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:20</th>
                    <td>イザ</td>
                    <td>65:1LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:21</th>
                    <td>イザ</td>
                    <td>65:2LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:3</th>
                    <td>王上</td>
                    <td>19:10,14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:4</th>
                    <td>王上</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:8</th>
                    <td>申</td>
                    <td>29:3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>イザ</td>
                    <td>29:10</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:9―10</th>
                    <td>詩</td>
                    <td>69:23―24LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:26―27a</th>
                    <td>イザ</td>
                    <td>59:20―21LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:27b</th>
                    <td>イザ</td>
                    <td>27:9LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:34</th>
                    <td>イザ</td>
                    <td>40:13LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:35</th>
                    <td>ヨブ</td>
                    <td>41:3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:19</th>
                    <td>申</td>
                    <td>32:35</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:20</th>
                    <td>箴</td>
                    <td>25:21―22LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:9a</th>
                    <td>出</td>
                    <td>20:13―15,17</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:17―19,21</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:9b</th>
                    <td>レビ</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">14:11a</th>
                    <td>イザ</td>
                    <td>49:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">14:11b</th>
                    <td>イザ</td>
                    <td>45:23LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:3</th>
                    <td>詩</td>
                    <td>69:10</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:9</th>
                    <td>詩</td>
                    <td>18:50</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>（＝サム下</td>
                    <td>22:50）</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:10</th>
                    <td>申</td>
                    <td>32:43</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:11</th>
                    <td>詩</td>
                    <td>117:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:12</th>
                    <td>イザ</td>
                    <td>11:10LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:21</th>
                    <td>イザ</td>
                    <td>52:15LXX</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">コリントの信徒への手紙 1</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:19</th>
                    <td>イザ</td>
                    <td>29:14LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:31</th>
                    <td>エレ</td>
                    <td>9:23</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:9</th>
                    <td>イザ</td>
                    <td>64:3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:16</th>
                    <td>イザ</td>
                    <td>40:13LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:19</th>
                    <td>ヨブ</td>
                    <td>5:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:20</th>
                    <td>詩</td>
                    <td>94:11</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:13</th>
                    <td>申</td>
                    <td>17:7LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:16</th>
                    <td>創</td>
                    <td>2:24</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:9</th>
                    <td>申</td>
                    <td>25:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:7</th>
                    <td>出</td>
                    <td>32:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:26</th>
                    <td>詩</td>
                    <td>24:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">14:21</th>
                    <td>イザ</td>
                    <td>28:11―12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:27</th>
                    <td>詩</td>
                    <td>8:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:32</th>
                    <td>イザ</td>
                    <td>22:13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:45</th>
                    <td>創</td>
                    <td>2:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:54</th>
                    <td>イザ</td>
                    <td>25:8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">15:55</th>
                    <td>ホセ</td>
                    <td>13:14LXX</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">コリントの信徒への手紙 2</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:13</th>
                    <td>詩</td>
                    <td>116:10LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:2</th>
                    <td>イザ</td>
                    <td>49:8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:16</th>
                    <td>レビ</td>
                    <td>26:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>エゼ</td>
                    <td>37:27</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:17a</th>
                    <td>イザ</td>
                    <td>52:11</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:17b</th>
                    <td>エゼ</td>
                    <td>20:34</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:18</th>
                    <td>サム下</td>
                    <td>7:8,14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">8:15</th>
                    <td>出</td>
                    <td>16:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:9</th>
                    <td>詩</td>
                    <td>112:9</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:17</th>
                    <td>エレ</td>
                    <td>9:23</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:1</th>
                    <td>申</td>
                    <td>19:15</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">ガラテヤの信徒への手紙</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:6</th>
                    <td>創</td>
                    <td>15:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:8</th>
                    <td>創</td>
                    <td>12:3</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td></td>
                    <td>18:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:10</th>
                    <td>申</td>
                    <td>27:26LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:11</th>
                    <td>ハバ</td>
                    <td>2:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:12</th>
                    <td>レビ</td>
                    <td>18:5</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:13</th>
                    <td>申</td>
                    <td>21:23</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:16</th>
                    <td>創</td>
                    <td>12:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:27</th>
                    <td>イザ</td>
                    <td>54:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:30</th>
                    <td>創</td>
                    <td>21:10</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:14</th>
                    <td>レビ</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">エフェソの信徒への手紙</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:8</th>
                    <td>詩</td>
                    <td>68:19</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:25</th>
                    <td>ゼカ</td>
                    <td>8:16</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:26</th>
                    <td>詩</td>
                    <td>4:5LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:31</th>
                    <td>創</td>
                    <td>2:24</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:2―3</th>
                    <td>出</td>
                    <td>20:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:16</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">テモテへの手紙 1</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:18</th>
                    <td>申</td>
                    <td>25:4</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">テモテへの手紙 2</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:19</th>
                    <td>民</td>
                    <td>16:5</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">ヘブライ人への手紙</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:5a</th>
                    <td>詩</td>
                    <td>2:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:5b</th>
                    <td>サム下</td>
                    <td>7:14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:6</th>
                    <td>申</td>
                    <td>32:43LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:7</th>
                    <td>詩</td>
                    <td>104:4LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:8―9</th>
                    <td>詩</td>
                    <td>45:7―8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:10―12</th>
                    <td>詩</td>
                    <td>102:26―28LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:13</th>
                    <td>詩</td>
                    <td>110:1</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:6―8</th>
                    <td>詩</td>
                    <td>8:5―7LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:12</th>
                    <td>詩</td>
                    <td>22:23</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:13a</th>
                    <td>イザ</td>
                    <td>8:17LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:13b</th>
                    <td>イザ</td>
                    <td>8:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:7―11</th>
                    <td>詩</td>
                    <td>95:7―11</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:15</th>
                    <td>詩</td>
                    <td>95:7―8LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:3,5</th>
                    <td>詩</td>
                    <td>95:11</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:4</th>
                    <td>創</td>
                    <td>2:2</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:7</th>
                    <td>詩</td>
                    <td>95:7―8LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:5</th>
                    <td>詩</td>
                    <td>2:7</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:6</th>
                    <td>詩</td>
                    <td>110:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">6:13―14</th>
                    <td>創</td>
                    <td>22:16―17</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:1―2</th>
                    <td>創</td>
                    <td>14:17―20</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">7:17,21</th>
                    <td>詩</td>
                    <td>110:4</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">8:5</th>
                    <td>出</td>
                    <td>25:40</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">8:8―12</th>
                    <td>エレ</td>
                    <td>31:31―34</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">9:20</th>
                    <td>出</td>
                    <td>24:8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:5―7</th>
                    <td>詩</td>
                    <td>40:7―9LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:16―17</th>
                    <td>エレ</td>
                    <td>31:33―34</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:30</th>
                    <td>申</td>
                    <td>32:35―36</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">10:37―38</th>
                    <td>ハバ</td>
                    <td>2:3―4LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:5</th>
                    <td>創</td>
                    <td>5:24LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:18</th>
                    <td>創</td>
                    <td>21:12</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">11:21</th>
                    <td>創</td>
                    <td>47:31LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:5―6</th>
                    <td>箴</td>
                    <td>3:11―12LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:20</th>
                    <td>出</td>
                    <td>19:12―13</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:21</th>
                    <td>申</td>
                    <td>9:19</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">12:26</th>
                    <td>ハガ</td>
                    <td>2:6LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:5</th>
                    <td>申</td>
                    <td>31:6,8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">13:6</th>
                    <td>詩</td>
                    <td>118:6LXX</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">ヤコブの手紙</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:8</th>
                    <td>レビ</td>
                    <td>19:18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:11</th>
                    <td>出</td>
                    <td>20:13―14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row"></th>
                    <td>申</td>
                    <td>5:17―18</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:23</th>
                    <td>創</td>
                    <td>15:6</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:6</th>
                    <td>箴</td>
                    <td>3:34LXX</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">ペトロの手紙 1</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:16</th>
                    <td>レビ</td>
                    <td>19:2</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">1:24―25</th>
                    <td>イザ</td>
                    <td>40:6―8</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:6</th>
                    <td>イザ</td>
                    <td>28:16LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:7</th>
                    <td>詩</td>
                    <td>118:22</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:8</th>
                    <td>イザ</td>
                    <td>8:14</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:9a</th>
                    <td>イザ</td>
                    <td>43:20LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:9b</th>
                    <td>出</td>
                    <td>19:6LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:9c</th>
                    <td>イザ</td>
                    <td>43:21LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:22</th>
                    <td>イザ</td>
                    <td>53:9</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">3:10―12</th>
                    <td>詩</td>
                    <td>34:13―17</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">4:18</th>
                    <td>箴</td>
                    <td>11:31LXX</td>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">5:5</th>
                    <td>箴</td>
                    <td>3:34LXX</td>
                  </tr>
                  <tr class="quote-book table-secondary">
                    <th scope="row" colspan="3">ペトロの手紙 2</th>
                  </tr>
                  <tr class="quote-data">
                    <th scope="row">2:22</th>
                    <td>箴</td>
                    <td>26:11</td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1 px-3" style="cursor: pointer;" v-b-toggle.reference-accordion-8>
            度量衡および通貨
          </b-card-header>
          <b-collapse id="reference-accordion-8">
            <b-card-body>
              <p>本聖書では，長さ，広さ，重さ，容量，通貨などの単位を，原則として，原語の発音に近いままの形で表記している。以下の表は，これら各単位についてのおよその量ないし額を知る手がかりとして，メートル法換算の概数ないし，他の単位との間の比率を示したものである。なお配列は，五十音順によった。</p>

              <table class="table table-bordered mt-5">
                <thead>
                  <tr class="measuring-book table-secondary">
                    <th scope="row">単位</th>
                    <th>種類<br>概数ないし関係比率</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="measuring-data">
                    <th scope="row">アサリオン</th>
                    <td>新約・通貨<br>ローマの青銅貨で，1デナリオンの1/16</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">アンマ</th>
                    <td>旧約・長さ<br>ひじから中指の先までの長さで，約45㎝（従来訳の“キュビト”に相当） （注1）</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">エファ</th>
                    <td>旧約・固体の容量<br>約23ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">オメル</th>
                    <td>旧約・固体の容量<br>1エファの1/10，約2.3ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">オルギィア</th>
                    <td>新約・長さ<br>約1.85m</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">カブ</th>
                    <td>旧約・固体の容量<br>1エファの1/18，約1.3ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">キカル</th>
                    <td>旧約・重さ<br>約34.2㎏</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">クァドランス</th>
                    <td>新約・通貨<br>ローマの青銅貨で，1デナリオンの1/64</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ケシタ</th>
                    <td>旧約・重さ<br>交易に用いた単位で，重さは不明</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ゲラ</th>
                    <td>旧約・重さ<br>1シェケルの1/20，約0.6g</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">コイニクス</th>
                    <td>新約・容量<br>約1.1ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ゴメド</th>
                    <td>旧約・長さ<br>長さは不明</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">コル</th>
                    <td>旧約・液体の容量<br>ホメルと同量，約230ℓ （注2）</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">コロス</th>
                    <td>新約・固体の容量<br>約230ℓ（従来訳の「石（こく）」に相当）</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">サトン</th>
                    <td>新約・容量<br>約12.8ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">シェケル</th>
                    <td>旧約・重さ<br>発見されている分銅の平均値では約11.4g</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">シェケル銀貨</th>
                    <td>旧約・通貨<br>もともとはペルシアの銀貨で，重さ約5.6g。ダリク金貨の1/20に相当</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">スコイノス</th>
                    <td>続編・長さ<br>約5.5㎞</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">スタディオン</th>
                    <td>新約・長さ<br>約185m，ミリオンの1/8</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">セア</th>
                    <td>旧約・固体の容量<br>1エファの1/3，約7.7ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ゼレト</th>
                    <td>旧約・長さ<br>手を広げたときの親指の先から，小指の先までの長さで，約22.5㎝。1アンマの1/2 （注1）</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">タラントン</th>
                    <td>新約，続編・通貨<br>ギリシアで用いた計算用の単位で，6,000ドラクメに相当</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ダリク金貨</th>
                    <td>旧約・通貨<br>前6世紀以来，ペルシア帝国の金貨で重さ約8.4g</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">樽（たる）</th>
                    <td>続編・液体の容量<br>約39ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ツェメド</th>
                    <td>旧約・広さ<br>軛でつないだ1組の牛が1日に耕作する土地の広さで，約2,500平方メートル</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">デナリオン</th>
                    <td>新約・通貨<br>ローマの銀貨で，1デナリオンは，1ドラクメと等価（1日の賃金に当たる）</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">トファ</th>
                    <td>旧約・長さ<br>指4本の幅で，アンマの1/6，約7.5㎝</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ドラクメ</th>
                    <td>旧約，新約・通貨<br>ギリシアの銀貨で，重さ約4.3g，デナリオンと等価</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">バト</th>
                    <td>旧約・液体の容量<br>1コルの1/10，約23ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">バトス</th>
                    <td>新約・液体の容量<br>約23ℓ，旧約のバトに相当</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ピム</th>
                    <td>旧約・重さ<br>1シェケルの2/3。約7.6gの重さで，交易の単位であった</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ヒン</th>
                    <td>旧約・液体の容量<br>1バトの1/6，約3.8ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ベカ</th>
                    <td>旧約・重さ<br>1シェケルの1/2，約5.7g</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ペキス</th>
                    <td>新約・長さ<br>約45㎝，旧約の1アンマに等しい</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ホメル</th>
                    <td>旧約・固体の容量<br>約230ℓ （注2）</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">升（ます）</th>
                    <td>続編・容量<br>約56ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">マネ</th>
                    <td>旧約・重さ<br>1シェケルの50倍の重さで約570g（注3）</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ミリオン</th>
                    <td>新約・長さ<br>約1,480m</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ムナ</th>
                    <td>新約・通貨<br>ギリシアの銀貨で，1ムナは100ドラクメに相当</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">メトレテス</th>
                    <td>新約・液体の容量<br>約39ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">指（ゆび）</th>
                    <td>旧約・長さ<br>指の幅，約1.9㎝</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">レテク</th>
                    <td>旧約・固体の容量<br>1ホメルの1/2，約115ℓ</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">リトラ</th>
                    <td>新約・重さ<br>約326g</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">レプトン</th>
                    <td>新約・通貨<br>最小の銅貨で，1デナリオンの1/128</td>
                  </tr>
                  <tr class="measuring-data">
                    <th scope="row">ログ</th>
                    <td>旧約・液体の容量<br>約0.3ℓ，1バトの1/72</td>
                  </tr>
                </tbody>
              </table>
              <p>（注1） 「アンマ」と「ゼレト」はエゼキエル書に限り（40：5，43：13，17参照），それぞれ約52.5㎝と26.25㎝。</p>
              <p>（注2） 「コル」「ホメル」は旧約の容量の基準であったが，長い旧約時代を通じ，いつも一定の単位が同じ容量を示すものとして用いられたわけではない。1ホメルは最近の研究では，200ℓと400ℓの間で変化していたとする説があるが，ここでは他の同系単位の量を示すための便宜上約230ℓとした。</p>
              <p>（注3） エゼ45：12の1マネは1シェケルの60倍で約684g。</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1 px-3" style="cursor: pointer;" v-b-toggle.reference-accordion-9>
            聖書協会とは
          </b-card-header>
          <b-collapse id="reference-accordion-9">
            <b-card-body>
              <p>「誰もが自分の言葉で自由に読める聖書を、適正な価格で手にすることができるように」その願いを実現するために、聖書協会の働きは1804年に英国で開始されました。日本における聖書普及活動は、1875（明治8）年、スコットランド聖書協会の日本支社設置に始まりました。翌年米国、英国の聖書協会がそれぞれ日本支社を設置、これらは、1937（昭和12）年に日本人による組織として合併し、日本聖書協会となりました。1949（昭和24）年には「財団法人」として認可され、2012（平成24）年に一般財団法人となっています。</p>
              <p>日本聖書協会は、日本国内の諸教会と諸団体のご支援とご協力を得ながら、聖書の翻訳、出版、頒布、普及をして、御言葉をすべての人にお届けすることを目的としています。また日本聖書協会は、聖書協会世界連盟（United Bible Societies）の一員として、各国の聖書協会と同一組織・同一理念・同一使命をもって相互に協力し合いながら、全世界の聖書普及に努めています。</p>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </b-tab>

  <b-tab class="d-flex flex-column">
    <template slot="title">
      <i class="far fa-play-circle fa-fw"></i>
    </template>

    <div class="flex-shrink-1">
    </div>

    <div class="flex-grow-1 overflow-y-s">
      <template v-if="$store.state.data.current.chapter.media_libraries">
        <app-navbar class="mb-2 d-md-none" :nomenu="true" />
        <template v-if="$store.state.data.current.chapter.media_libraries.vimeo && $store.state.data.current.chapter.media_libraries.vimeo.data">
          <div class="video-outer js-vimeo-outer">
            <iframe class="video js-video-change" :src="'https://player.vimeo.com/video/' + ($store.state.data.current.chapter.media_libraries.vimeo.data.uri.split('/').pop()) + '?playsinline=0&portrait=0&byline=0&title=0'" frameborder="0" allowfullscreen></iframe>

          </div>
          ・朗読が聴ける訳は「聖書協会共同訳」のみです<br>
          <span class="text-danger">※朗読音声の、個人的な利用を超えた使用や複製はご遠慮ください。</span><br>
        </template>
        <p v-else>
          ウェブバイブルのプレミアム版で、聖書協会共同訳の旧約聖書の全39書、新約聖書の全27書および旧約聖書続編の全13書の朗読を聴くことができます。いずれかの書を開いて、メニューの「朗読を聴く」ボタンをクリックまたはタップして再生してお聴きください。
        </p>
      </template>

      <app-buy-layer ticket="premium" variant="light" />
    </div>
  </b-tab>

  <b-tab class="d-flex flex-column">
    <template slot="title">
      <i class="far fa-cog fa-fw"></i>
    </template>

    <div class="flex-shrink-1">
    </div>

    <div class="flex-grow-1 overflow-y-s">
      <b-form-group label="るび" v-if="$store.state.data.current.bible.ruby">
        <b-form-radio-group
          buttons
          button-variant="outline-primary"
          v-model="$store.state.setting.ruby.value"
          :options="$store.state.setting.ruby.options"
          name="radiosBtnDefault"
          @input="onToggleRuby"
          />
      </b-form-group>

      <b-form-group label="引照" v-if="$store.state.data.current.bible.reference">
        <b-form-radio-group
          buttons
          button-variant="outline-primary"
          v-model="$store.state.setting.reference.value"
          :options="$store.state.setting.reference.options"
          name="radiosBtnDefault"
          @input="onToggleReference"
          />
      </b-form-group>

      <b-form-group label="注" v-if="$store.state.data.current.bible.annotation">
        <b-form-radio-group
          buttons
          button-variant="outline-primary"
          v-model="$store.state.setting.annotation.value"
          :options="$store.state.setting.annotation.options"
          name="radiosBtnDefault"
          @input="onToggleAnnotation"
          />
      </b-form-group>

      <b-form-group label="小見出し" v-if="$store.state.data.current.bible.subheading">
        <b-form-radio-group
          buttons
          button-variant="outline-primary"
          v-model="$store.state.setting.subheading.value"
          :options="$store.state.setting.subheading.options"
          name="radiosBtnDefault"
          @input="onToggleSubheading"
          />
      </b-form-group>

      <b-form-group label="続編" v-if="$store.state.data.current.bible.apocrypha">
        <b-form-radio-group
          buttons
          button-variant="outline-primary"
          v-model="$store.state.setting.apocrypha.value"
          :options="$store.state.setting.apocrypha.options"
          name="radiosBtnDefault"
          @input="onToggleApocrypha"
          />
      </b-form-group>

      <b-form-group label="スタディ注（プレミアム版）" v-if="$store.state.data.current.bible.study">
        <b-form-radio-group
          buttons
          button-variant="outline-primary"
          v-model="$store.state.setting.study.value"
          :options="$store.state.setting.study.options"
          name="radiosBtnDefault"
          @input="onToggleStudy"
          />
      </b-form-group>

      <fieldset class="form-group">
        <legend class="col-form-label pt-0">文字サイズ</legend>
        <div class="d-flex">
          <b-button :variant="'outline-primary'" @click="onClickFontSizeDown"><i class="far fa-fw fa-font"></i><sup>-</sup></b-button>
          <b-progress :value="$store.state.setting.fontSize.value" :max="$store.state.setting.fontSize.max" height="38px" class="flex-grow-1"></b-progress>
          <b-button :variant="'outline-primary'" @click="onClickFontSizeUp"><i class="far fa-fw fa-font"></i><sup>+</sup></b-button>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend class="col-form-label pt-0">行間</legend>
        <div class="d-flex">
          <b-button :variant="'outline-primary'" @click="onClickVSpaceDown"><i class="far fa-fw fa-align-justify"></i><sup>-</sup></b-button>
          <b-progress :value="$store.state.setting.vspace.value" :max="$store.state.setting.vspace.max" height="38px" class="flex-grow-1"></b-progress>
          <b-button :variant="'outline-primary'" @click="onClickVSpaceUp"><i class="far fa-fw fa-align-justify"></i><sup>+</sup></b-button>
        </div>
      </fieldset>
    </div>
  </b-tab>

  <b-tab class="d-flex flex-column">
    <template slot="title">
      <i class="far fa-user fa-fw"></i>
    </template>

    <div class="flex-shrink-1">
    </div>

    <div class="flex-grow-1 overflow-y-s">
      <app-bible-tool-profile />
    </div>
  </b-tab>

  <b-tab class="d-flex flex-column">
    <template slot="title">
      <i class="far fa-question-circle fa-fw"></i>
    </template>

    <div class="flex-grow-1 overflow-y-s">
      <div role="tablist" class="w-100">
        <b-card no-body class="mb-4">
          <b-card-header header-tag="header" class="p-1 px-3" role="tab">
            マニュアル・ヘルプ・お問い合わせ
          </b-card-header>
          <b-card-body>
            <b-link class="btn w-100 btn-primary text-white" href="https://manual.si.jbsbibleapp.com/" target="_blank">ウェブバイブル マニュアルページへ</b-link>
          </b-card-body>
        </b-card>

        <b-card no-body class="mb-4">
          <b-card-header header-tag="header" class="p-1 px-3" role="tab">
            規定など
          </b-card-header>
          <b-card-body>
            <b-link href="https://manual.si.jbsbibleapp.com/terms.html" target="_blank">
                利用規約<br>
                プライバシーポリシー<br>
                特定商取引法所定の記載事項
            </b-link>
          </b-card-body>
        </b-card>

        <b-card no-body class="mb-4">
          <b-card-header header-tag="header" class="p-1 px-3" role="tab">
            コピーライト
          </b-card-header>
          <b-card-body>
            <strong>このウェブアプリについて</strong>
            <p>このウェブアプリは、日本聖書協会が発行したものです。</p>
            <p>章のない書巻についても、便宜上「章」を表記しています。</p>
            <p>本ウェブアプリ内のプログラム、聖書データを著作者に無断でコピー、転用、営利目的で使用することは、法律によって禁止されています。</p>
            <p>本ウェブアプリに搭載されている『聖書  聖書協会共同訳』（ベーシック版、プレミアム版）、『聖書  聖書協会共同訳』『聖書 新共同訳』『聖書 新共同訳』『聖書 1954年、1955年改訳（＝口語訳聖書）』『English Standard Version』「『スタディ版聖書』傍注」（プレミアム版）に関するお問い合わせは、<a href="mailto:transl@bible.or.jp">日本聖書協会</a>までお願いします。</p>
            <p>&nbsp;</p>
            
            <strong>ベーシック版、プレミアム版</strong>
            <p>序文、本文、巻末付録（地図以外）：『聖書 聖書協会共同訳』©2018 日本聖書協会</p>
            <p>地図：Maps taken from The Learning Bible. Contemporary English Version, ©2000 American Bible Society. Used by permission. All rights reserved.</p>
            <p>&nbsp;</p>
            
            <strong>プレミアム版</strong>
            <p>『聖書 新共同訳』©️1987, 1988 共同訳聖書実行委員会 日本聖書協会</p>
            <p>『聖書 1954年、1955年改訳』©1954, 1955, 1975, 1984, 2002 日本聖書協会</p>
            <p>&nbsp;</p>
            
            <strong>English Standard Version</strong>
            <p><u>Copyright Notice</u></p>
            <p>The Holy Bible, English Standard Version © 2001 Crossway Bibles, a publishing ministry of Good News Publishers. All rights reserved.</p>
            <p>This publication contains the ESV® Bible (The Holy Bible, English Standard Version® ), copyright © 2001 by Crossway Bibles, a publishing ministry of Good News Publishers. ESV Text Edition: 2016. The ESV®  Text has been reproduced in cooperation with and by permission of Good News Publishers. Unauthorized reproduction of this publication is prohibited.</p>
            <p><u>Permissions Notice</u></p>
            <p>The ESV text may be quoted (in written, visual, or electronic form) up to and inclusive of five hundred (500) consecutive verses without express written permission of the publisher, provided that the verses quoted do not amount to a complete book of the Bible nor do the verses quoted account for twenty-five percent (25%) or more of the total text of the work in which they are quoted. </p>
            <p>The ESV text may be quoted for audio use (audio cassettes, CDs, audio television) up to five hundred (500) verses without express written permission of the publisher provided that the verses quoted do not amount to a complete book of the Bible nor do the verses quoted account for twenty-five percent (25%) or more of the total text of the work in which they are quoted.</p>
            <p>Notice of copyright must appear as follows on the title page or copyright page of printed works quoting from the ESV, or in a corresponding location when the ESV is quoted in other media:</p>
            <p>“Scripture quotations are from The ESV® Bible (The Holy Bible, English Standard Version®), copyright © 2001 by Crossway, a publishing ministry of Good News Publishers. Used by permission. All rights reserved.”</p>
            <p>When more than one translation is quoted in printed works or other media, the foregoing notice of copyright should begin as follows:</p>
            <p>“Unless otherwise indicated, all Scripture quotations are from . . . [etc.]”; or, “Scripture quotations marked (ESV) are from . . . [etc.].”</p>
            <p>“ESV,” the “English Standard Version,” the “Global Study Bible,” and the ESV logo are registered trademarks of Good News Publishers. Use of any of these trademarks beyond the use of this Permission Notice requires the permission of Good News Publishers.</p>
            <p>When quotations from the ESV text are used in non-saleable media, such as church bulletins, orders of service, posters, transparencies, or similar media, a complete copyright notice is not required, but the initials (ESV) must appear at the end of the quotation.</p>
            <p>Publication of any commentary or other Bible reference work produced for commercial sale that uses the English Standard Version (ESV) must include written permission for use of the ESV text.</p>
            <p>Permission requests that exceed the above guidelines must be directed to Good News Publishers, Attn: Bible Rights, 1300 Crescent Street, Wheaton, Ill. 60187, USA.</p>
            <p>Permission requests for use within UK and EU that exceed the above guidelines must be directed to: HarperCollins Religious, 77-85 Fulham Palace Road, Hammersmith, London, W6 8JB, England.</p>
            <p><u>Trademarks and Acknowledgment</u></p>
            <p>English Standard Version, ESV and the ESV logo are registered trademarks of Good News Publishers. Used by permission.</p>
            <p>&nbsp;</p>
            
            <strong>『聖書 スタディ版』傍注</strong>
            <p>Notes from The Learning Bible. Contemporary English Version, ©2000 American Bible Society.</p>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </b-tab>
</b-tabs>
</template>

<script>
import jQuery from 'jquery'
import moment from 'moment'

import AppBibleToolProfile from '@/components/AppBibleToolProfile.vue'
import AppBuyLayer from '@/components/AppBuyLayer.vue'
import AppNavbar from '@/components/AppNavbar.vue'

export default {
  components: {
    AppBibleToolProfile,
    AppBuyLayer,
    AppNavbar,
  },
  data: function () {
    this.$store.dispatch('dataSetBibleSearchBookCode')

    return {
      moment: moment,
      formatter: new Intl.NumberFormat('ja-JP'),
      overview: {
        value: null,
      },
      reference: {
        value: 0,
        content: `
          `,
        items: [
        ],
      },
      search: {
        value: '',
        items: [
        ],
        response: null,
        connecting: false,
      },
      user: {
        email: '',
        password: '',
      },
      errors: {
      },
    };
  },
  computed: {
    computed: {
      get () {
        return {
          search: {
          },
        }
      },
      set (value) {},
    },
  },
  methods: {
    onClickOverviewBibleBook ($event, item) {
      this.overview.value = item
      setTimeout(() => {
        this.$scrollTo(
          jQuery('#overview-top')[0],
          1,
          {
            container: jQuery('#overview-container')[0],
          }
        )
      }, 300)
    },
    onClickOverviewBack ($event, item) {
      this.overview.value = null
      setTimeout(() => {
        this.$scrollTo(
          jQuery('#overview-top')[0],
          1,
          {
            container: jQuery('#overview-container')[0],
          }
        )
      }, 300)
    },
    onToggleRuby () {
      this.$store.dispatch('settingToggleRuby', this.$store.state.setting.ruby.value)
    },
    onToggleReference () {
      this.$store.dispatch('settingToggleReference', this.$store.state.setting.reference.value)
    },
    onToggleAnnotation () {
      this.$store.dispatch('settingToggleAnnotation', this.$store.state.setting.annotation.value)
    },
    onToggleSubheading () {
      this.$store.dispatch('settingToggleSubheading', this.$store.state.setting.subheading.value)
    },
    onToggleApocrypha () {
      this.$store.dispatch('settingToggleApocrypha', this.$store.state.setting.apocrypha.value)
    },
    onToggleStudy () {
      this.$store.dispatch('settingToggleStudy', this.$store.state.setting.study.value)
    },
    onClickFontSizeUp: function () {
      if (this.$store.state.setting.fontSize.value < this.$store.state.setting.fontSize.max) {
        this.$store.state.setting.fontSize.value++
      }
      this.$store.dispatch('settingChangeFontSize', this.$store.state.setting.fontSize.value)
    },
    onClickFontSizeDown: function () {
      if (this.$store.state.setting.fontSize.value > this.$store.state.setting.fontSize.min) {
        this.$store.state.setting.fontSize.value--
      }
      this.$store.dispatch('settingChangeFontSize', this.$store.state.setting.fontSize.value)
    },
    onClickVSpaceUp: function () {
      if (this.$store.state.setting.vspace.value < this.$store.state.setting.vspace.max) {
        this.$store.state.setting.vspace.value++
      }
      this.$store.dispatch('settingChangeVSpace', this.$store.state.setting.vspace.value)
    },
    onClickVSpaceDown: function () {
      if (this.$store.state.setting.vspace.value > this.$store.state.setting.vspace.min) {
        this.$store.state.setting.vspace.value--
      }
      this.$store.dispatch('settingChangeVSpace', this.$store.state.setting.vspace.value)
    },
    onClickSearchSubmit: function () {
      this.search.items = []
      this.search.connecting = true
      this.$store.dispatch(
        'dataBibleSearch',
        {
          bibleCode: this.$store.state.data.current.bible.code,
          bookCode: this.$store.state.data.search.bookCode,
          keyword: this.search.value,
        }
      ).then(function (response) {
        this.search.response = response
        this.search.items = this.search.items.concat(response.data.item)
      }.bind(this)).catch(function (error) {
      }.bind(this)).then(function () {
        this.search.connecting = false
      }.bind(this))
    },
    onClickSearchMore: function () {
      const url = this.search.response.config.url.split('/');

      this.search.connecting = true
      this.$store.dispatch(
        'dataBibleSearch',
        {
          bibleCode: url[url.length - 2],
          bookCode: this.search.response.config.params.book,
          keyword: this.search.response.config.params.q,
          skip: this.search.items.length,
        }
      ).then(function (response) {
        this.search.response = response
        this.search.items = this.search.items.concat(response.data.item)
      }.bind(this)).catch(function (error) {
      }.bind(this)).then(function () {
        this.search.connecting = false
      }.bind(this))
    },
    onKeyupSearchKeyword: function (e) {
      if (e.key == 'Enter') {
        this.onClickSearchSubmit();
      }
    },
    onClickSearchItem: function (e, item) {
      const indexes = {
        bible: item.bible.code,
        book: item.book.code,
        chapter: item.chapter.order,
        verse: item.order,
        pushHistory: true,
      }
      this.$store.dispatch('dataBibleOpenWithIndex', indexes)
      this.$store.dispatch('uiToggleModalBibleTool', false)
//      $refs.bibleModalTool.hide()
    },
  },
  async mounted () {
  },
};
</script>

<style lang="scss">
.vimeo-id-outer {
    input {
        margin-right: 10px;
        margin-bottom: 10px;
    }
    button {
        margin-bottom: 10px;
    }
}
.video-outer {
    position: relative;
    height: 0;
    padding: 0 0 56.25%;
    overflow: hidden;
    margin-bottom: 20px;
}
/* iframe */
.video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
}
</style>


